<ng-template #termsPrivacyDialog>
  <div class="countable-dialog policy-dialog">
    <div mat-dialog-title class="dialog-header pb-24">
      <h4 class="title">{{titleLabel}}</h4>
      <!-- <p class="m-0">{{countryId}}countryId</p> -->
       @if(isShowAcceptButton()){
        <button color="error" class="close" [mat-dialog-close]="false">
          <i class="fa-regular fa-xmark clear-icon"></i>
        </button>
      }
    </div>

    <div mat-dialog-content class="dialog-body-content pt-0" #scrollToTopEle>
      <mat-tab-group class="countable-tabs sticky-labels" [selectedIndex]="selectedIndex ? selectedIndex : null"
        (selectedIndexChange)="onChangeTab($event)" [dynamicHeight]="true">
        <mat-tab>
          <ng-template mat-tab-label>
            Terms of use
          </ng-template>
          <ng-template matTabContent>
            <div class="terms-privacy-section">
              <ng-container>
                <p class="mar-b-15rem">Last Updated: October 25, 2024</p>
                <div class="terms-of-use">
                  <div class="text-center mb-3">
                    <h4>COUNTABLE</h4>
                    <h4>SOFTWARE AS A SERVICE (SAAS) TERMS AND CONDITIONS</h4>
                  </div>
                  <p class="mar-b-15rem">
                    <span class="fw-semibold">These Software as a Service (SaaS) and Services Terms and
                      Conditions</span>
                    (“<span class="fw-semibold">Terms</span>” or this “<span class="fw-semibold">Agreement”</span>)
                    govern
                    the purchase of the license to the Software, the access to Services and the use of the Website by
                    the
                    Firm and its Users (“<span class="fw-semibold">you</span>”, “<span class="fw-semibold">your</span>”,
                    and terms of similar meaning) made available by Countable Inc. (“<span
                      class="fw-semibold">we</span>”,
                    “<span class="fw-semibold">us</span>”, “<span class="fw-semibold">Provider</span>” and terms of
                    similar meaning) and its suppliers.
                  </p>
                  <p class="mar-b-15rem">
                    By accepting this Agreement, by (a) clicking a box indicating acceptance, (b) accepting or executing
                    an Order Form that references this Agreement, or (c) otherwise accessing or using the Services or
                    the
                    Website, you agree to be bound by these Terms, and all terms, policies and guidelines incorporated
                    by
                    reference in these Terms. If a Firm registers for a free trial of the Services, the applicable
                    provisions of these Terms will also govern that free trial.
                  </p>
                  <p class="mar-b-15rem">
                    If the individual accepting this Agreement is accepting on behalf of a company or legal entity, such
                    individual represents that they have the authority to bind such entity and its affiliates to these
                    Terms, in which case the term “Firm” or “User” (as the case may be) shall refer to such entity and
                    its
                    affiliates. If the individual accepting this Agreement does not have such authority, or does not
                    agree
                    with these Terms, such individual must not accept this Agreement and may not use the Services or the
                    Website.
                  </p>
                  <p class="mar-b-15rem">
                    Order Forms are automatically deemed to include all of the terms and conditions of these Terms;
                    provided that whenever the provisions of the Order Form expressly conflict with these Terms, the
                    conflicting provisions of the Order Form control and shall take precedence over the conflicting
                    provisions of the Terms.
                  </p>


                  <div class="term-content-block flexbox-column gap-16 1">
                    <h6 class="title d-flex gap-4 text-uppercase">
                      <span>1.</span>
                      <span>Definitions</span>
                    </h6>

                    <ul class="ps-3 policy-list list-style-none">
                      <li class="policy-list-item d-flex gap-4">
                        <span>1.1</span>
                        <p><span class="fw-semibold">“Administrator”</span> means a person or persons assigned by the
                          Firm
                          to have the authority to act as the administrator of the subscription on behalf of the Firm.
                        </p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>1.2</span>
                        <p><span class="fw-semibold">“Applicable Law”</span> means all applicable requirements, laws,
                          statutes, codes, acts, ordinances, orders, decrees, injunctions, by-laws, rules, regulations,
                          permits, licenses, authorizations, directions and agreements with all applicable government
                          authorities, agencies, bodies or departments, having jurisdiction over this Agreement or the
                          supply or use of the Services.</p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>1.3</span>
                        <p><span class="fw-semibold">“Business Day”</span> means any day except Saturday, Sunday or any
                          day on which banks are generally not open for business in the City of Toronto, Ontario.</p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>1.4</span>
                        <p><span class="fw-semibold">“CASL”</span> means any applicable federal, provincial and local
                          laws, regulations and rules governing the sending of commercial electronic messages.</p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>1.5</span>
                        <p><span class="fw-semibold">“Client”</span> means a client of the Firm.</p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>1.6</span>
                        <p><span class="fw-semibold">“Cloud Provider”</span> has the meaning given in Section 6.1.</p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>1.7</span>
                        <p><span class="fw-semibold">“Consulting Services”</span> means any Consulting Services, other
                          than the use of the Software and related services, authorized by the Firm that the Provider
                          agrees to perform or is required to perform hereunder. The Consulting Services shall include,
                          but are not limited to, software development, integration, data migration, customization,
                          configuration, and implementation services, as further described in the Order Form or a
                          Schedule.</p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>1.8</span>
                        <p><span class="fw-semibold">“Co-Pilot”</span> has the meaning given in Section 5.2.</p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>1.9</span>
                        <p><span class="fw-semibold">“Fees”</span> means the fees to be paid by the Firm pursuant to an
                          Order Form, these Terms and any applicable Schedules.
                        </p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>1.10</span>
                        <p><span class="fw-semibold">“Firm”</span> shall mean the individual or organization who is
                          bound
                          by the terms of an Order Form and these Terms and Conditions.
                        </p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>1.11</span>
                        <p><span class="fw-semibold">“Firm Data”</span> means any data or content inputted into the
                          Software by the Firm or any of its employees or Users, including, but not limited to Firm
                          Marks,
                          engagement letters, signature lines, pre-drafted footers, data relating to Clients of the
                          Firm,
                          Input prompts and feedback provided in relation to the Services.
                        </p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>1.12</span>
                        <p><span class="fw-semibold">“Firm Marks”</span> means the Firm’s trademarks (registered and
                          unregistered), trade names, designs, logos and other indicia of origin that are uploaded by
                          the
                          Firm or its Users onto the Software or Website.
                        </p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>1.13</span>
                        <p><span class="fw-semibold">“FlexPlan Services”</span> means the managed services that the
                          Provider provides to the Firm pursuant to an Order Form.
                        </p>
                      </li>

                      <li class="policy-list-item d-flex gap-4">
                        <span>1.14</span>
                        <p><span class="fw-semibold">“FlexPlan Terms”</span> shall have the meaning set forth in Section
                          4.1.
                        </p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>1.15</span>
                        <p><span class="fw-semibold">“Input”</span> means a User prompt, submission, or interaction
                          posed
                          to the Co-Pilot or Software, including any Firm Data, shall be deemed an “<span
                            class="fs-semibold">Input</span>”.
                        </p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>1.16</span>
                        <p><span class="fw-semibold">“Order Firm”</span> means (i) the Countable Platform as a Service
                          (SaaS) Order Form; (ii) an online order through the Website or email confirmation specifying
                          the
                          Services to be provided hereunder, that is entered into between the Firm and the Provider,
                          including any Schedules, addenda and supplements thereto.
                        </p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>1.17</span>
                        <p><span class="fw-semibold">“Output”</span> means the AI-generated content produced in response
                          to an Input by the Firm or its Users, including, but not limited to, textual content,
                          spreadsheets, PDF documents, and chatbot responses.
                        </p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>1.18</span>
                        <p><span class="fw-semibold">“Personal Information”</span> means any information relating to
                          identifiable individuals, the collection, use or disclosure of which is regulated by Privacy
                          Laws.
                        </p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>1.19</span>
                        <p><span class="fw-semibold">“Privacy Laws”</span> means any applicable federal, provincial and
                          local laws, regulations and rules governing the collection, use and disclosure of information
                          relating to identifiable individuals, including the Personal Information Protection and
                          Electronic Documents Act (Canada), the Personal Information Protection Act (British Columbia),
                          the Personal Information Protection Act (Alberta), and any similar legislation enacted by any
                          province or territory of Canada.</p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>1.20</span>
                        <p><span class="fw-semibold">“Schedule”</span> means a schedule, which is attached to this
                          Agreement, or which may be added hereafter by written agreement of the parties.</p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>1.21</span>
                        <p><span class="fw-semibold">“Services”</span> means the use of the Software, Consulting
                          Services
                          and related services, including the FlexPlan Services and the Co-Pilot, to be provided by the
                          Provider to the Firm pursuant to the Order Form.</p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>1.22</span>
                        <p><span class="fw-semibold">“Software”</span> means the Countable automated workflow platform
                          as
                          a service and other related software, data and content made available by the Provider and
                          licensed to the Firm and the number of User licenses purchased by the Firm pursuant to the
                          terms
                          of the Order Form.</p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>1.23</span>
                        <p><span class="fw-semibold">“Term”</span> shall have the meaning given in Section 12.1.</p>
                      </li>

                      <li class="policy-list-item d-flex gap-4">
                        <span>1.24</span>
                        <p><span class="fw-semibold">“Third Party Content”</span> means any data owned or licensed by a
                          third party and inputted into the Software. For greater certainty, Third Party Content
                          includes,
                          but is not limited to Professional Engagement Forms (PEG Forms) and other content provided by
                          CPA Canada.</p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>1.25</span>
                        <p><span class="fw-semibold">“Third Party LLM”</span> means any third-party large language
                          models
                          and other AI tools used by the Provider to process Firm Data to generate Output in the
                          Software
                          for the Firm and its Users.
                        </p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>1.26</span>
                        <p><span class="fw-semibold">“User”</span> means an individual user who (i) accesses the Website
                          and/or is permitted to use the Software; and (ii) agreed to these Terms. Users may include
                          Administrators, employees or contractors of the Firm and Clients who are authorized to use the
                          Services.
                        </p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>1.27</span>
                        <p><span class="fw-semibold">“Website”</span> Adinovis website made available <a
                            class="text-link" href="https://www.countable.co">
                            www.countable.co</a> or its sub domains or domains with identical names under other top
                          domains and owned by Provider.
                        </p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>1.28</span>
                        <p><span class="fw-semibold">“Work Product”</span> means any materials or deliverables generated
                          as part of the consulting services and any related work, offered by the provider to the firm
                          in
                          accordance with the terms of an order form or a schedule. WORK PRODUCT SPECIFICALLY EXCLUDES
                          THE
                          SOFTWARE AND THE SERVICES OR ANY PRE-EXISTING, THIRD PARTY, OPEN-SOURCE MATERIAL, OR ANY
                          DEVELOPMENT THAT IS INTENDED BY THE PROVIDER TO BE AN ENHANCEMENT TO THE SOFTWARE OR ANY NEW
                          SOFTWARE DEVELOPED BY THE PROVIDER THAT IS INTENDED TO BE OWNED BY THE PROVIDER, AND THE
                          CLIENT
                          DATA.
                        </p>
                      </li>
                    </ul>
                  </div>

                  <div class="term-content-block flexbox-column gap-16 2">
                    <h6 class="title d-flex gap-4 text-uppercase">
                      <span>2.</span>
                      <span>Privacy and Security</span>
                    </h6>

                    <ul class="ps-3 policy-list list-style-none">
                      <li class="policy-list-item d-flex gap-4">
                        <span>2.1</span>
                        <p>Please refer to the privacy policy by clicking here (the "<span class="fw-semibold">
                            @if(isLoginPage()){
                            Privacy
                            Policy (
                            <span (click)="goToPolicyTab(1)" class="text-link">Canada</span> / <span
                              (click)="goToPolicyTab(2)" class="text-link">US</span>
                            )
                            } @else{
                            <span (click)="goToPolicyTab(1)" class="text-link">Privacy
                              Policy</span>
                            }
                          </span>") for information on how we
                          or our licensors collect, use and disclose your Personal Information. By using the Services
                          and
                          the Website, you agree to the use, collection and disclosure of personally identifiable
                          information in accordance with the Privacy Policy.</p>
                      </li>
                    </ul>
                  </div>

                  <div class="term-content-block flexbox-column gap-16 3">
                    <h6 class="title d-flex gap-4 text-uppercase">
                      <span>3.</span>
                      <span>Consulting Services and Responsibilities</span>
                    </h6>

                    <ul class="ps-3 policy-list list-style-none">
                      <li class="policy-list-item d-flex gap-4">
                        <span>3.1</span>
                        <p><span class="fw-semibold text-italic">Consulting Services.</span> The Provider shall perform
                          the Consulting Services in accordance with an Order Form, these Terms, and the applicable
                          Schedule(s), and in a timely, diligent and professional manner. The Order Form and each
                          Schedule
                          is automatically deemed to include all of the terms and conditions of this Agreement; provided
                          that whenever the provisions of an Order or Schedule expressly conflict with these terms and
                          conditions, the conflicting provisions of the Order Form control and take precedence over the
                          conflicting provisions of these terms and conditions, but only for purposes of the Order Form
                          or
                          Schedule.</p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>3.2</span>
                        <p><span class="fw-semibold text-italic"> Work Schedule.</span> Unless they are expressly
                          described as firm deadlines, in which case the Provider’s obligation shall be to meet such
                          dates, any schedules, deadlines or timeframes set forth in an Order Form or a Schedule
                          represent
                          estimates that the Provider shall use its reasonable commercial efforts to achieve. The Client
                          acknowledges that the Provider’s successful and timely performance of the Consulting Services
                          is
                          dependent on the active participation and collaboration of the Firm, its employees and
                          representatives. The Provider shall not be liable for any delay or cost or expense caused as a
                          result of the delay of the Firm provided that the Provider has notified the Firm of such
                          delay.
                        </p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>3.3</span>
                        <p><span class="fw-semibold text-italic"> Accteptance.</span> Where an Order Form or a Schedule
                          contemplates the development of a deliverable or Work Product, the Firm shall have a period to
                          review and accept the completed deliverables or Work Product (such period to be specified in
                          the
                          Order Form or the applicable Schedule, or a five (5) business days if no period is specified)
                          and the Provider shall have a period to remedy any deficiencies identified by the Firm (such
                          period to be as specified in the Order Form or applicable Schedule, or a reasonable period if
                          no
                          period is specified). The Firm shall provide the Provider prompt notice of any deficiencies
                          identified by the Firm. If the Firm does not give written notice of any deficiencies within
                          such
                          period, it shall be deemed to have accepted the Deliverables.</p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>3.4</span>
                        <p><span class="fw-semibold text-italic"> Firm Representation and Warranties.</span> The Firm
                          represents and warrants that the Client’s use of the Consulting Services and the use of the
                          Consulting Services by the Firm’s directors, officers, employees, contractors, representatives
                          and other agents will (a) be consistent with the Order Form and these Terms, and any licenses
                          provided; and (b) comply with Applicable Law, including without limitation Privacy Laws.</p>
                      </li>
                    </ul>
                  </div>

                  <div class="term-content-block flexbox-column gap-16 4">
                    <h6 class="title d-flex gap-4 text-uppercase">
                      <span>4.</span>
                      <span>User Accounts</span>
                    </h6>

                    <ul class="ps-3 policy-list list-style-none">
                      <li class="policy-list-item d-flex gap-4">
                        <span>4.1</span>
                        <p><span class="fw-semibold text-italic"> Provisioning and User Accounts.</span> Upon agreeing
                          to
                          an Order Form, the initial Administrator of the Firm will be permitted to register for a User
                          account. The initial Administrator may add other Administrators and authorize Users subject to
                          the limitations and additional terms described in the Order Form. The Initial Administrator
                          and
                          other Administrators shall be deemed to have the authority to manage (including adding and
                          removing) Users. Administrators may deactivate any User if the Administrator wishes to
                          terminate
                          access to the Service for any User. Access to specific features of the Services are only
                          available to specific user types.</p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>4.2</span>
                        <p><span class="fw-semibold text-italic"> Free Trial.</span> If a Firm agrees to a free trial
                          pursuant to an Order Form or registers for a free trial on the Website (“Free Trial”), the
                          Provider will make the applicable Services available to the Firm on a trial basis free of
                          charge
                          until the earlier of (a) the end of the Free Trial period for which the Firm registered to use
                          the applicable Services, or (b) the start date of the Initial Term under an Order Form.
                          Additional trial terms and conditions may appear on the Website’s Free Trial registration
                          page.
                          Any such additional terms and conditions are incorporated into these Terms by reference. Any
                          Firm Data accumulated by a User during a Free Trial will be permanently lost unless the User,
                          on
                          behalf of a Firm, agrees to an Order Form or exports such Firm Data before the end of the Free
                          Trial period. Notwithstanding anything to the contrary in Sections 10 and 11, during the Free
                          Trial, the Services are provided “as-is” without any warranty, support or service levels and
                          the
                          Provider shall have no indemnification obligations nor liability of any type with respect to
                          the
                          Services for the Trial Period unless such exclusion of liability is not enforceable under
                          Applicable Law in which case the Provider’s liability with respect to those Services provided
                          during the Free Trial shall not exceed $1,000.</p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>4.3</span>
                        <p><span class="fw-semibold text-italic"> Registration.</span> Upon logging into the Software
                          for
                          the first time, the Administrators and Users will be prompted to register for a User account.
                          Administrators and Users agree to: (a) provide accurate, current and complete information as
                          may
                          be prompted by any registration forms on the Software or the Website (“<span
                            class="fw-semibold">Registration Data</span>”); (b) maintain the security of the their
                          password; (c) maintain and promptly update the Registration Data, and any other information
                          they
                          provide to the Software or the Website, and to keep it accurate, current and complete; and (d)
                          accept all risks of unauthorized access to the Registration Data and any other information
                          provided to Provider. The Firm shall be responsible for all activity by Users on the Software,
                          including the activity performed on the Software through the User accounts by an agent,
                          representative, employee (including former employees who maintained access to the Services),
                          or
                          any other person acting on behalf of such User. It is the responsibility of the Firm to delete
                          User accounts or otherwise remove access to Users who should no longer be active (e.g. a User
                          who is no longer an employee or contractor of the Firm or a Vendor of the Firm).</p>
                      </li>
                    </ul>
                  </div>

                  <div class="term-content-block flexbox-column gap-16 5">
                    <h6 class="title d-flex gap-4 text-uppercase">
                      <span>5.</span>
                      <span>Services</span>
                    </h6>

                    <ul class="ps-3 policy-list list-style-none">
                      <li class="policy-list-item d-flex gap-4">
                        <span>5.1</span>
                        <p><span class="fw-semibold text-italic">FlexPlan Services.</span> Upon the Firm’s request for
                          the
                          FlexPlan Services, the Provider will provide an Order Form detailing such FlexPlan Services.
                          Each such Order Form is binding on both Parties and any FlexPlan Services will be governed by
                          the terms of the applicable Order Form, these Terms and the FlexPlan Terms and Conditions
                          available here (the “<span class="fw-semibold">FlexPlan Terms</span>”).</p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>5.2</span>
                        <p><span class="fw-semibold text-italic">AI Generated Content and Acknowledgement.</span> The
                          Services may include features (referred herein as the “Co-Pilot”) that allow the Firm and its
                          Users to (a) interact with an AI-enabled chatbot which utilizes Third-Party LLMs to present
                          information pursuant to User preferences, interactions, and queries; and (b) utilize
                          artificial
                          intelligence to generate Output based on Input and Firm Data. <span
                            class="text-decoration-underline">Co-Pilot and related features of the Services are
                            currently
                            in beta, and, as such, are provided to Users solely for evaluation purposes only. As such,
                            you
                            acknowledge that artificial intelligence and machine learning are evolving technologies and
                            understand that the Output made available by such features may not be accurate or reflect
                            reliable information. When using the Services, you understand and agree that (i) all Output
                            may not be accurate, and that you will not refer to such Output as factual information or as
                            a
                            substitute for accounting advice; (ii) you are solely responsible for evaluating the
                            accuracy
                            of such Output; (iii) you will not solely rely on Output as constituting formal accounting
                            advice, and will always ensure that any Output is reviewed or vetted accordingly by a duly
                            licensed and qualified accountant; (iv) the Services may deliver Output that is not endorsed
                            or affiliated with the Provider and is not representative of the Provider’s views.</span>
                          Notwithstanding anything to the contrary in Sections 11 and 12, any Services provided
                          utilizing
                          Co-Pilot are provided "as-is" without any warranty, support or service levels and the Provider
                          shall have no indemnification obligations nor liability of any type with respect to such
                          Services unless such exclusion of liability is not enforceable under Applicable Law in which
                          case the Provider's liability with respect to those Services provided shall not exceed $1,000.
                        </p>
                      </li>
                    </ul>
                  </div>

                  <div class="term-content-block flexbox-column gap-16 6">
                    <h6 class="title d-flex gap-4 text-uppercase">
                      <span>6.</span>
                      <span>License to Software, Website and License Restrictions</span>
                    </h6>

                    <ul class="ps-3 policy-list list-style-none">
                      <li class="policy-list-item d-flex gap-4">
                        <span>6.1</span>
                        <p><span class="fw-semibold text-italic">License to Software and Website.</span> Provider hereby
                          grants to Firm and authorized Users a non-exclusive, non-transferable license to use the
                          Software and the Website and solely permit the Firm and Users to use the Website and the
                          functionality contained within the Software for legitimate purposes during the Term.</p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>6.2</span>
                        <p><span class="fw-semibold text-italic">License Restrictions.</span> Except as set forth in
                          this
                          Agreement, the Order Form, any Schedule and to the extent contrary by Applicable Law: the Firm
                          and User may not <span class="fw-semibold text-italic">(a)</span> make or distribute copies of
                          the Software or Website; <span class="fw-semibold text-italic">(b)</span> alter, merge, adapt
                          or
                          translate the Software or Website, or decompile, reverse engineer, disassemble, or otherwise
                          reduce the Software or Website to a human-perceivable form; <span
                            class="fw-semibold text-italic">(c)</span> sell, rent, lease, host or sublicense the
                          Software
                          (except as is incidental or necessary for the provision of the Software to Users); <span
                            class="fw-semibold text-italic">(d)</span> modify the Software or Website or create
                          derivative
                          works based upon the Software or Website; provided however that the foregoing will not
                          restrict
                          Firm’s rights to exploit any Firm Data which may be incorporated into, reside in, or form a
                          part
                          of the Software; <span class="fw-semibold text-italic">(e)</span> use the Services or the
                          Website in a manner that breaches the rights of any third party, any contract or legal duty or
                          violate any Applicable Law; <span class="fw-semibold text-italic">(f)</span> copy the Services
                          or Website or any part, feature, function or user interface thereof; <span
                            class="fw-semibold text-italic">(g)</span> access or use the Services or Website in order to
                          build a competitive product or service; <span class="fw-semibold text-italic">(h)</span> use
                          the
                          Services or Website other than for its intended purposes; <span
                            class="fw-semibold text-italic">(i)</span> do anything to interfere with or impair the
                          intended operation of the Website; <span class="fw-semibold text-italic">(j)</span> use the
                          Software, including Co-Pilot or any data or Output to directly or indirectly create, train,
                          test
                          or otherwise improve any artificial intelligence or machine learning algorithms,
                          architectures,
                          weights, models, systems or the like.</p>
                      </li>
                    </ul>
                  </div>

                  <div class="term-content-block flexbox-column gap-16 7">
                    <h6 class="title d-flex gap-4 text-uppercase">
                      <span>7.</span>
                      <span>Hosting and Support</span>
                    </h6>

                    <ul class="ps-3 policy-list list-style-none">
                      <li class="policy-list-item d-flex gap-4">
                        <span>7.1</span>
                        <p><span class="fw-semibold text-italic">Hosting.</span> The Provider will cause the Software to
                          be hosted on a cloud server maintained by a reputable third party provider (<span
                            class="fw-semibold">“Cloud Provider”</span>). The Provider will be responsible for
                          contracting
                          with the Cloud Provider, and for paying all fees and charges of the Cloud Provider. All Firm
                          Data stored on the Services is located on servers operated by the Cloud Provider in the Canada
                          and/or the United States.</p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>7.2</span>
                        <p><span class="fw-semibold text-italic">Support Training.</span> Support, maintenance and
                          training Services are provided to the Firm in accordance with the terms of the Provider’s
                          <span class="text-decoration-underline">“Service Level Agreement”</span>.</p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>7.3</span>
                        <p><span class="fw-semibold text-italic">Backups.</span> The Provider will create a backup or
                          cause its Cloud Provider to create a backup of the Software (including all Firm Data) no less
                          frequently than once every twenty-four (24) hours. Upon request from the Firm, the Provider
                          will
                          provide the Firm with a copy of the most recent backup available.</p>
                      </li>
                    </ul>
                  </div>

                  <div class="term-content-block flexbox-column gap-16 8">
                    <h6 class="title d-flex gap-4 text-uppercase">
                      <span>8.</span>
                      <span>Firm Representations and Warranties; Firm Responsibilities</span>
                    </h6>

                    <ul class="ps-3 policy-list list-style-none">
                      <li class="policy-list-item d-flex gap-4">
                        <span>8.1</span>
                        <p><span class="fw-semibold text-italic">Firm Representations and Warranties.</span> The Firm
                          represents and warrants that <span class="fw-semibold">(a)</span> the Firm’s use of the
                          Services
                          or Website and the use of the Services or Website by the Firm’s Users will <span
                            class="fw-semibold">(i)</span> be consistent with this Agreement and any licenses provided;
                          and <span class="fw-semibold">(ii)</span> comply with Applicable Law, including Privacy Laws
                          and
                          CASL; <span class="fw-semibold">(b)</span> it has and shall maintain in effect all the
                          licenses,
                          permissions, authorizations, consents and permits that it needs to carry out its obligations
                          under this Agreement; <span class="fw-semibold">(c)</span> it has the right to enter into this
                          Agreement and to allow the Provider to perform the Services; <span
                            class="fw-semibold">(d)</span> it has obtained all rights in the Firm Data necessary to
                          permit
                          compliance with its obligations under these Terms. The Firm shall be liable for the acts and
                          omissions of any of its Users, directors, officers, employees, contractors, representatives or
                          agents as if such act or omission were an act or omission of the Firm.</p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>8.2</span>
                        <p><span class="fw-semibold text-italic">Requirement Active Subscription to CPA Canada
                            PEG.</span>
                          The Firm agrees that the Firm and its Users access to the Software and Services is conditional
                          upon the Firm having an active subscription to the CPA Canada Professional Engagement Guide
                          (PEG) at all times during the Term. The Provider reserves the right, in its sole discretion,
                          without any notice or liability to the Firm or any User, to impose limits, change, suspend or
                          terminate the Firm or any User’s license to use the Software, or any portion thereof, for
                          failure to comply with this Section 7.2.</p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>8.3</span>
                        <p><span class="fw-semibold text-italic">Additional Responsibilities.</span> The Firm agrees (a)
                          that it shall be responsible for providing and maintaining its own Internet access with the
                          necessary bandwidth speeds as recommended by the Provider and all necessary telecommunications
                          equipment, services, software and other materials (collectively, <span
                            class="fw-semibold">“Firm
                            Equipment”</span>) at the Firm’s location(s) necessary for accessing the Services; and (b)
                          the
                          Firm is solely responsible for (i) providing, updating, uploading, modifying and maintaining
                          the
                          Firm Data; (ii) the accuracy and legality of the Firm Data as and when provided by the Firm to
                          the Provider; and (iii) the means by which it acquires and uses such Firm Data (including,
                          without limitation, privacy and data protection).</p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>8.4</span>
                        <p><span class="fw-semibold text-italic">Firm Indemnity Regarding Use of Services and Website
                            and
                            Firm Data.</span> The Firm shall be solely responsible for all inputs, selection and use of
                          the Services and Website and all Firm Data or other data transmitted, received or created
                          using
                          the Services or Website, even if transmitted, received or created by someone else, and the
                          Firm
                          agrees to defend, indemnify and hold the Provider, its directors, officers, employees, agents,
                          contractors and affiliates harmless from any loss, damage or liability which may result
                          therefrom or from any breach by the Firm or its Users of this Agreement.</p>
                      </li>
                      <li class="policy-list-item d-flex flex-column gap-8">
                        <div class="flexbox-row gap-4 align-items-start">
                          <span>8.5</span>
                          <p class="m-0"><span class="fw-semibold text-italic">Acceptable Use of the Services and
                              Website.
                              The Firm and its Users may not:</span></p>
                        </div>

                        <ul class="policy-child-list ps-3 list-style-none">
                          <li class="policy-list-item d-flex gap-4">
                            <span>(a)</span>
                            <p>Use, or encourage, promote, facilitate or instruct others to use the Services or the
                              Website for any illegal, harmful or offensive use or to transmit, store, display,
                              distribute
                              or otherwise make available content that is illegal, harmful or offensive;</p>
                          </li>
                          <li class="policy-list-item d-flex gap-4">
                            <span>(b)</span>
                            <p>Use the Services or the Website to violate the security or integrity of any network,
                              computer or communications system, software application, or network or computing device;
                            </p>
                          </li>
                          <li class="policy-list-item d-flex gap-4">
                            <span>(c)</span>
                            <p>Make network connections to any users, hosts, or networks unless the Firm has permission
                              to
                              communicate with them; and/or</p>
                          </li>
                          <li class="policy-list-item d-flex gap-4">
                            <span>(d)</span>
                            <p>distribute, publish, send or facilitate the sending of unsolicited mass e-mail or other
                              messages, promotions, advertising or solicitations (like ‘spam’), including commercial
                              advertising and informational announcements.</p>
                          </li>
                          <li class="policy-list-item d-flex gap-4">
                            <p>The Provider reserves the right, but does not assume the obligation, to investigate any
                              violation of this Section or misuse of the Services or Website.</p>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>

                  <div class="term-content-block flexbox-column gap-16 9">
                    <h6 class="title d-flex gap-4 text-uppercase">
                      <span>9.</span>
                      <span>Fees, Expenses and Payment</span>
                    </h6>

                    <ul class="ps-3 policy-list list-style-none">
                      <li class="policy-list-item d-flex gap-4">
                        <span>9.1</span>
                        <p><span class="fw-semibold text-italic">Fees.</span> In consideration for the Services
                          described
                          herein, the Firm shall pay to the Provider, in advance, the Fees more particularly described
                          in
                          an Order Form and any applicable Schedules. Except as otherwise specified herein or in the
                          Order
                          Form, (i) the Fees are based on the Services purchased and not actual usage, (ii) payment
                          obligations are non-cancelable and Fees paid are non-refundable, (iii) a subscription type
                          (pertaining to certain User quantities) cannot be decreased during the relevant subscription
                          term; and (iv) the Firm will be billed in advance on a recurring, periodic basis (each period
                          is
                          called a <span class="fw-semibold">“billing cycle”</span>). Billing cycles are typically
                          monthly
                          or annual, depending on what subscription plan the Firm selects when purchasing the Services.
                        </p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>9.2</span>
                        <p><span class="fw-semibold text-italic">Invoices and Payments.</span> The Provider shall
                          invoice
                          the Firm, in advance, for the Services in accordance with the terms of the Order Form. The
                          Firm
                          shall pay such invoices within five (5) calendar days of receipt (or such other time as
                          specified in the Order Form or any Schedule). Taxes shall be identified and shown as separate
                          items on each invoice. Late payments are subject to interest in the amount of two percent (2%)
                          per month on overdue amounts and interest thereon.</p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>9.3</span>
                        <p><span class="fw-semibold text-italic">Taxes.</span> The Firm shall be responsible for all
                          applicable sales, goods and services, harmonized sales, value added, use, excise, other
                          similar
                          taxes, levies and charges not otherwise included in the Fees imposed by applicable tax
                          authorities on the provision of Services hereunder. The Firm shall pay to the Provider such
                          taxes, levies and charges which the Provider is registered to charge and collect.</p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>9.4</span>
                        <p><span class="fw-semibold text-italic">Suspension of Service and Acceleration.</span> If any
                          charge owing by the Firm under these Terms or any other agreement is thirty (30) days or more
                          overdue, the Provider may, without limiting its other rights and remedies, accelerate the
                          Firm’s
                          unpaid fee obligations under such agreements, so that all such obligations become immediately
                          due and payable, and suspend the Services until such amounts are paid in full.</p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>9.5</span>
                        <p><span class="fw-semibold text-italic">Change to Fees.</span> Subject to an Order Form, the
                          Provider reserves the right to introduce new or change any Fees on or related to the Services
                          from time to time, upon providing the Client with thirty (30) days advanced written notice, by
                          e-mailing the Administrator(s) of the Firm and/or by posting the updated Fees (or the
                          pertinent
                          calculations) on the Website or displaying a notification in the Software. If the Firm does
                          not
                          accept the changed or new Fees, the Firm must terminate these Terms or amend its Services
                          prior
                          to the end of the thirty (30) day period. After such period, if the Terms are not terminated
                          or
                          the Services are not amended, the Firm’s or any of its Users continued use of the Services
                          after
                          the effective date of the change indicates the Firm’s agreement with the new or changed Fees.
                        </p>
                      </li>
                    </ul>
                  </div>

                  <div class="term-content-block flexbox-column gap-16 10">
                    <h6 class="title d-flex gap-4 text-uppercase">
                      <span>10.</span>
                      <span>Intellectual Property, Firm Data and Privacy</span>
                    </h6>

                    <ul class="ps-3 policy-list list-style-none">
                      <li class="policy-list-item d-flex gap-4">
                        <span>10.1</span>
                        <p><span class="fw-semibold text-italic">Ownership of the Software and Website.</span> Except
                          for
                          any grant of licenses in this Agreement or as otherwise expressly provided in this Agreement,
                          the Provider and its licensors, as applicable, shall retain all copyright, patent rights,
                          trade
                          secret rights, trademarks and other proprietary rights or interests (<span
                            class="fw-semibold text-italic">“Intellectual Property Rights”</span>) in the Software and
                          Website. Nothing in this Agreement, the Order Form, or any Schedules shall be deemed to convey
                          to the Firm or any other party, any ownership right, in or to Software and Website.</p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>10.2</span>
                        <p><span class="fw-semibold text-italic">Ownership of Firm Data.</span> The Provider
                          acknowledges
                          and agrees that, as between the Parties, the Firm is the sole and exclusive owner of the Firm
                          Data and any Outputs, and that no right or interest in the Firm Data, other than pursuant to
                          Section 10.3 of this Agreement, and will be collected, handled and used by the Provider only
                          in
                          compliance with the terms of this Agreement. Due to the nature of the Co-Pilot, Output may not
                          be unique and other users may receive similar output from the Software.</p>
                      </li>
                      <li class="policy-list-item d-flex flex-column gap-8">
                        <div class="flexbox-row gap-4 align-items-start">
                          <span>10.3</span>
                          <p><span class="fw-semibold text-italic">License from Firm to Provider.</span> The Firm hereby
                            grants to the Provider a non-exclusive, royalty-free, non-transferable, limited right to use
                            during the Term, Firm Data and Output provided to the Provider solely to perform and improve
                            the Services pursuant to this Agreement. Without limiting the foregoing, the Provider shall
                            process the Firm Data in certain ways to power the Provider’s Co-Pilot features, including
                            sending Firm Data to its Third Party LLM to generate Output. In doing so, the Provider shall
                            not share the Firm Data with other firms or third parties for any purposes except those
                            provided below. Accordingly:</p>
                        </div>

                        <ul class="policy-child-list ps-3 list-style-none">
                          <li class="policy-list-item d-flex flex-column gap-8">
                            <div class="flexbox-row gap-4 align-items-start">
                              <span>(a)</span>
                              <p class="m-0">Regarding data processing by Third Party LLMs, the Firm understands,
                                acknowledges, and agrees that:</p>
                            </div>

                            <ul class="policy-sub-child-list ps-3 list-style-none">
                              <li class="policy-list-item d-flex gap-4">
                                <span>(i)</span>
                                <p>The Provider shall transmit Inputs to its Third Party LLM in order to generate Output
                                  and retrieve Output from Third Party LLM to provide to the Firm; all such transmitted
                                  and retrieved Firm Data shall be encrypted in transit according to industry standard
                                  encryption protocols.</p>
                              </li>
                              <li class="policy-list-item d-flex gap-4">
                                <span>(ii)</span>
                                <p>The Provider shall only transmit Firm Data as needed to Third Party LLMs to deliver
                                  the
                                  Services contemplated in the Order Form. The Firm Data will not be used to train Third
                                  Party LLMs, unless explicitly consented to, in writing, by the Firm.</p>
                              </li>
                              <li class="policy-list-item d-flex gap-4">
                                <span>(iii)</span>
                                <p>Behavioral data generated through interactions with the Provider’s Co-Pilot features
                                  (e.g. usage patterns and error logs) will not include any Firm Data or personally
                                  identifiable information. Behavioral data will not be shared with providers of Third
                                  Party LLMs but may be used by the Provider to improve the Services, optimize workflows
                                  and for other internal purposes.</p>
                              </li>
                            </ul>
                          </li>
                        </ul>

                        <ul class="policy-child-list ps-3 list-style-none">
                          <li class="policy-list-item d-flex flex-column gap-8">
                            <div class="flexbox-row gap-4 align-items-start">
                              <span>(b)</span>
                              <p class="m-0">Regarding the Provider’s internal data processing activities, the Firm
                                understands, acknowledges, and agrees to the following:</p>
                            </div>

                            <ul class="policy-sub-child-list ps-3 list-style-none">
                              <li class="policy-list-item d-flex gap-4">
                                <span>(i)</span>
                                <p>The Provider only collects, processes, stores, or otherwise uses Firm Data as
                                  necessary
                                  to perform Services that the Firm has purchased in an Order Form, or perform other
                                  activities specifically requested by its Users. </p>
                              </li>
                              <li class="policy-list-item d-flex gap-4">
                                <span>(ii)</span>
                                <p>The Provider collects and analyzes non-identifying analytics data, such as Users’
                                  quantitative usage metrics and other statistical information, relating to the Firm’s
                                  use
                                  and performance of various aspects of the Services, and analyzes such data to improve
                                  and enhance the Services, as well as to diagnose and correct issues associated with
                                  the
                                  Services.</p>
                              </li>
                              <li class="policy-list-item d-flex gap-4">
                                <span>(iii)</span>
                                <p>The Provider may process stored Firm Data to directly improve the quality of (and/or
                                  customize the experience of) the Services. This may include training internal
                                  artificial
                                  intelligence models for general product improvement or Firm-specific personalization.
                                </p>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>10.4</span>
                        <p><span class="fw-semibold text-italic">All Other Rights Reserved, Further Assurances.</span>
                          Except as expressly set forth herein or in the Order Form or a Schedule, all Intellectual
                          Property Rights are expressly reserved by the parties. The Firm or the Provider, as
                          applicable,
                          shall execute and deliver such instruments and take such other steps as may be requested by
                          the
                          Provider or the Firm, as applicable, from time to time in order to give effect to the
                          provisions
                          of this Article.</p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>10.5</span>
                        <p><span class="fw-semibold text-italic">Privacy Laws.</span> The Firm and authorized Users
                          represent that (a) they have complied with all applicable Privacy Laws in connection with the
                          collection, use and disclosure of Personal Information, and the provision of Personal
                          Information to the Provider complies with all applicable Privacy Laws; and (b) all individuals
                          to whom such Personal Information relates have consented to the Provider’s collection, use and
                          disclosure of such Personal Information for the purposes disclosed in this Agreement or our
                          Privacy Policy.</p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>10.6</span>
                        <p><span class="fw-semibold text-italic">Third Party/Open Source Content and Software.</span>
                          The
                          Software may contain or provide the ability to integrate the Services with Third Party
                          Content,
                          third party software and/or open source software, which may be subject to third party licenses
                          and require notices and/or additional terms and conditions (<span class="fw-semibold">“Third
                            Party Licenses”</span>). These Third Party Licenses are made a part of and incorporated into
                          these Terms. By accepting these Terms, the Firm and its Users are also accepting the Third
                          Party
                          Licenses, if any, set forth therein. To view the Third Party Licenses, please contact <a
                            class="text-link" href="mailto:info@countable.co">info&#64;countable.co</a>. The Firm and
                          all
                          authorized Users agree that the Provider has no liability arising from use of any integrations
                          or arising from such Third Party Content, third party software, open source software and
                          related
                          services. The Provider may modify or cancel the integrations at any time, without notice.</p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>10.7</span>
                        <p><span class="fw-semibold text-italic">License by Firm to Use Feedback.</span> The Firm grants
                          the Provider a worldwide, perpetual, irrevocable, royalty-free license to use and incorporate
                          into its services any suggestion, enhancement request, recommendation, correction or other
                          feedback provided by the Firm or Users relating to the operation of the Software, the
                          Services,
                          or the Website.</p>
                      </li>
                    </ul>
                  </div>

                  <div class="term-content-block flexbox-column gap-16 11">
                    <h6 class="title d-flex gap-4 text-uppercase">
                      <span>11.</span>
                      <span>Disclaimer and Limitation of Liability</span>
                    </h6>

                    <ul class="ps-3 policy-list list-style-none">
                      <li class="policy-list-item d-flex flex-column gap-8">
                        <div class="flexbox-row gap-4 align-items-start">
                          <span>11.1</span>
                          <p class="m-0"><span class="fw-semibold text-italic">Disclaimer</span></p>
                        </div>

                        <ul class="policy-child-list ps-3 list-style-none">
                          <li class="policy-list-item d-flex gap-4">
                            <span>(A)</span>
                            <p>EXCEPT AS EXPRESSLY SET OUT IN THE ORDER FORM, THIS AGREEMENT OR THE FLEXPLAN TERMS, IF
                              APPLICABLE, THE SERVICES AND THE WEBSITE ARE PROVIDED TO THE FIRM AND AUTHORIZED USERS ON
                              AN
                              “AS IS” BASIS, WITHOUT WARRANTIES FROM THE PROVIDER OF ANY KIND, EITHER EXPRESS OR
                              IMPLIED.
                              THE PROVIDER EXPRESSLY DISCLAIMS ALL OTHER WARRANTIES, EXPRESS OR IMPLIED, INCLUDING,
                              WITHOUT LIMITATION IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
                              PURPOSE,
                              TITLE AND NON-INFRINGEMENT, UNLESS OTHERWISE SPECIFIED IN THE APPLICABLE ORDER FORM. THE
                              PROVIDER DISCLAIMS ALL LIABILITY FOR ANY CONTENT POSTED ON THE WEBSITE THAT MAY BE
                              OUTDATED,
                              INACCURATE OR MISLEADING. THE PROVIDER DOES NOT WARRANT THAT THE SERVICES OR THE WEBSITE
                              WILL BE ERROR-FREE OR WILL OPERATE WITHOUT INTERRUPTION. ADDITIONALLY, THE PROVIDER DOES
                              NOT
                              REPRESENT OR WARRANT THAT ANY OUTPUT GENERATED BY THE SERVICES IS ACCURATE, COMPLETE, UP
                              TO
                              DATE, RELIABLE, CURRENT, ERROR-FREE OR SATISFACTORY TO THE FIRM AND AUTHORIZED USERS. THE
                              PROVIDER IS NOT LIABLE FOR ANY STATEMENTS OR REPRESENTATIONS INCLUDED IN ANY OUTPUT. </p>
                          </li>
                          <li class="policy-list-item d-flex gap-4">
                            <span>(B)</span>
                            <p>THE PROVIDER HAS NO CONTROL OVER THE OPERATION OF THE THIRD PARTY LLMS IT ACCESSES AS
                              PART
                              OF ITS PROCESSING ACTIVITIES, THE OUTPUTS THEY GENERATE, OR THE CONTINUED AVAILABILITY OF
                              ANY THIRD PARTY LLMS.</p>
                          </li>
                          <li class="policy-list-item d-flex gap-4">
                            <span>(C)</span>
                            <p>THE OUTPUT IS INTENDED TO PROVIDE PRACTICAL AND USEFUL INFORMATION ON THE SUBJECT MATTER
                              COVERED BASED ON THE FIRM AND USER INPUTS. WHILE SUCH OUTPUT MAY CONCERN ISSUES RELATED TO
                              ACCOUNTING SERVICES OR DOCUMENTS, SUCH CONTENT IS NOT FORMAL ACCOUNTING OR TAX ADVICE. THE
                              FIRM AND ITS USERS WILL NOT RELY ON ANY OUTPUT OF THE SERVICES WITHOUT SEEKING ADVICE OF,
                              AND/OR VETTING ANY OUTPUT THROUGH, A DULY LICENSED AND QUALIFIED PROFESSIONAL IN THE
                              APPLICABLE SUBJECT MATTER AND JURISDICTION. THE PROVIDER EXPRESSLY DISCLAIMS ALL LIABILITY
                              IN RESPECT OF FIRM OR USER ACTIONS TAKEN OR NOT TAKEN BASED ON ANY OUTPUT, OR OTHERWISE IN
                              CONNECTION WITH THE FIRM’S USE OF THE OUTPUT GENERATED FROM THE SERVICES.</p>
                          </li>
                          <li class="policy-list-item d-flex gap-4">
                            <span>(D)</span>
                            <p>THE FIRM UNDERSTANDS THAT IT, AND ITS USERS, ARE ULTIMATELY RESPONSIBLE FOR ALL DECISIONS
                              MADE, ACTIONS TAKEN, AND FAILURES TO TAKE ACTION BASED ON THE FIRM’S USE OF THE OUTPUT,
                              WHICH USES ARTIFICIAL INTELLIGENCE TO GENERATE PREDICTIONS BASED ON PATTERNS IN DATA.
                              OUTPUT
                              GENERATED BY ARTICIFICAL INTELLIGENCE (INCLUDING THIRD PARTY LLMS) IS PROBABILISTIC AND
                              SHOULD BE EVALUATED FOR ACCURACY AS APPROPRIATE FOR YOUR USE CASE.</p>
                          </li>
                        </ul>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>11.2</span>
                        <p><span class="fw-semibold text-italic">No Indirect, Etc. Damages.</span> Under no
                          circumstances
                          shall either party be liable to the other party for any claim for (i) indirect, special or
                          consequential damages, (ii) compensation for loss of profits, anticipated revenue, savings or
                          goodwill, or (iii) exemplary, aggravated or punitive damages howsoever incurred; in each case
                          under any theory of law or equity, arising out of or in any way related to this Agreement, the
                          FlexPlan Terms, or any Services, even if advised of the possibility thereof.</p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>11.3</span>
                        <p><span class="fw-semibold text-italic">Limitation of Aggregate Liability.</span> Except as
                          otherwise specifically provided under this Agreement, (a) the liability of either party for
                          any
                          claim, demand or cause of action whether based on contract, tort (including negligence) or
                          otherwise, or for any losses, damages, costs and expense (including but not limited to legal
                          fees) (collectively, “Losses”) arising out of or resulting from this Agreement or any of
                          Services, including the FlexPlan Services, shall not exceed the Fees paid or payable by the
                          Firm
                          to the Provider under this Agreement in the six (6) months preceding the Loss; and (b) the
                          Provider’s indemnification obligations hereunder will be limited to an amount equal to two (2)
                          times the Fees paid or payable by the Firm under this Agreement in the twelve (12) months
                          preceding the event giving rise to the indemnification obligation.</p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>11.4</span>
                        <p><span class="fw-semibold text-italic">Reasonableness of Limitations.</span> The Provider, the
                          Firm and Users agree that the limitations contained in this Section 10 are reasonable in scope
                          and form an integral part of this Agreement.</p>
                      </li>
                    </ul>
                  </div>

                  <div class="term-content-block flexbox-column gap-16 12">
                    <h6 class="title d-flex gap-4 text-uppercase">
                      <span>12.</span>
                      <span>Indemnification</span>
                    </h6>

                    <ul class="ps-3 policy-list list-style-none">
                      <li class="policy-list-item d-flex gap-4">
                        <span>12.1</span>
                        <p><span class="fw-semibold text-italic">Indemnity by Firm.</span> The Firm agrees to defend,
                          indemnify and hold the Provider, its directors, officers, employees, agents, contractors and
                          affiliates, harmless from any loss, damage or liability, including all reasonable legal costs,
                          that the Provider may incur as a result of or in connection with any third party claim
                          relating
                          to or resulting from (a) any breach by the Firm of the Firm’s obligations under this Agreement
                          or the FlexPlan Terms including its obligation to comply with all Applicable Law; or (b) any
                          third party claim that the Provider’s use of any Firm Data, including for generating Output,
                          or
                          Third Party Content infringes, misappropriates or otherwise violates the intellectual property
                          rights of any third party or any Privacy Laws.</p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>12.2</span>
                        <p><span class="fw-semibold text-italic">Indemnity by Provider.</span> Subject to Section 11.3
                          (Limitation of Aggregate Liability), the Provider agrees to defend, indemnify and hold the
                          Firm,
                          its directors, officers, employees, agents, contractors and affiliates, harmless from any
                          loss,
                          damage or liability, including all reasonable legal costs, that the Firm may incur as a result
                          of or in connection with: (a) any valid claim that the Software or any portion of it infringes
                          the intellectual property rights of any third party (an <span
                            class="fw-semibold">“Infringement
                            Claim”</span>); (b) any third-party claim relating to or resulting from any breach by the
                          Provider of the Provider’s obligations under this Agreement, including its obligation to
                          comply
                          with all Applicable Law; provided that, the Provider shall not be obligated to indemnify the
                          Firm to the extent that the Infringement Claim results from: (a) the Firm or any User’s breach
                          of this Agreement; (b) combination of the Services with any product or service not provided or
                          authorized in writing by Company (where such Infringement Claim would not have arisen but for
                          such combination); (c) modification of the Services other than performed or authorized in
                          writing by Company (where such Infringement Claim would not have arisen but for such
                          modification); or (d) the Firm or any User’s use of any Output from the Services.</p>
                      </li>
                    </ul>
                  </div>

                  <div class="term-content-block flexbox-column gap-16 13">
                    <h6 class="title d-flex gap-4 text-uppercase">
                      <span>13.</span>
                      <span>Term</span>
                    </h6>

                    <ul class="ps-3 policy-list list-style-none">
                      <li class="policy-list-item d-flex gap-4">
                        <span>13.1</span>
                        <p><span class="fw-semibold text-italic">Term.</span> The term of this Agreement (<span
                            class="fw-semibold">“Term”</span>) shall commence on the Effective Date set out in the Order
                          Form and, for subscription-based services, continue for length of time described in the Order
                          Form as the Initial Term (“Initial Term”). Thereafter, for subscription-based services, this
                          Agreement will automatically renew for successive terms equal to the length of time of the
                          Initial Term (“Renewal Terms”), unless terminated in accordance with this Agreement. The Term
                          of
                          this Agreement shall remain in effect until expiry or termination of all Services provided
                          under
                          any Order Form.</p>
                      </li>
                      <li class="policy-list-item d-flex flex-column gap-8">
                        <div class="flexbox-row gap-4 align-items-start">
                          <span>13.2</span>
                          <p class="m-0"><span class="fw-semibold text-italic">Termination.</span></p>
                        </div>

                        <ul class="policy-child-list ps-3 list-style-none">
                          <li class="policy-list-item d-flex gap-4">
                            <span>(a)</span>
                            <p><span class="fw-semibold text-italic">Prior to Renewal.</span> Except in the case of a
                              month-to-month term, either party may terminate this Agreement by providing written notice
                              to the other party at least (60) days prior to the end of the then current term. For
                              month-to-month terms, the Firm may provide thirty (30) days prior written notice to
                              terminate this Agreement. For greater certainty, such notice may be given prior to the end
                              of such current term but will only take effect at the end of the then current term.</p>
                          </li>
                          <li class="policy-list-item d-flex gap-4">
                            <span>(b)</span>
                            <p><span class="fw-semibold text-italic">Breach.</span> Either party may terminate this
                              Agreement if the other party materially breaches this Agreement, including any failure to
                              make payments when due, and such other party fails to cure such breach in all material
                              respects within thirty (30) days after being given notice of the breach from the
                              non-breaching party.</p>
                          </li>
                          <li class="policy-list-item d-flex gap-4 m-0">
                            <span>(c)</span>
                            <p><span class="fw-semibold text-italic">Insolvency.</span> Either party may terminate this
                              Agreement, upon written notice to the other party, if such other party is subject to
                              proceedings in bankruptcy or insolvency, voluntarily or involuntarily, if a receiver is
                              appointed with or without the other party’s consent, if the other party assigns its
                              property
                              to its creditors or performs any other act of bankruptcy, or if the other party becomes
                              insolvent and cannot pay its debts when they are due.</p>
                          </li>
                        </ul>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>13.3</span>
                        <p><span class="fw-semibold text-italic">Early Termination.</span> If this Agreement is
                          terminated
                          pursuant to Section 13.2 prior to the end of such current term, the Firm shall pay to the
                          Provider, as liquidated damages and not a penalty, an amount equal to the total monthly Fees
                          (as
                          described in the Order Form) multiplied by the number of months remaining prior to the end of
                          such current term.</p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>13.4</span>
                        <p><span class="fw-semibold text-italic">Termination and Suspension of Users.</span>
                          Notwithstanding any provision of these Terms, the Provider reserves the right, in its sole
                          discretion, without any notice or liability to the Firm or any User, to (a) terminate a User’s
                          license to use the Software, or any portion thereof; (b) block or prevent a User’s future
                          access
                          to and use of all or any portion of the Software or the Website; (c) change, suspend, or
                          discontinue any aspect of the Software or the Website; and (d) impose limits on the Software
                          or
                          Website.</p>
                      </li>
                      <li class="policy-list-item d-flex flex-column gap-8">
                        <div class="flexbox-row gap-4 align-items-start">
                          <span>13.5</span>
                          <p class="m-0"><span class="fw-semibold text-italic">Effect of Termination.</span> If this
                            Agreement is terminated in accordance with Section 13.2, then:</p>
                        </div>

                        <ul class="policy-child-list ps-3 list-style-none">
                          <li class="policy-list-item d-flex gap-4">
                            <span>(a)</span>
                            <p>Each party shall promptly deliver to the other party, all papers, databases, documents,
                              software programs, and other tangible items (including copies) constituting the other
                              party’s Confidential Information in its possession or under its control, or on request,
                              destroy such materials and certify that it has done so;</p>
                          </li>
                          <li class="policy-list-item d-flex gap-4">
                            <span>(b)</span>
                            <p>Upon a request by the Firm within thirty (30) days of termination, the Provider will
                              within
                              fifteen (15) days of such request, provide to the Firm a copy of the Firm Data in a format
                              that is readable using commercially available third party software and or the Software;
                              and
                            </p>
                          </li>
                          <li class="policy-list-item d-flex gap-4">
                            <span>(c)</span>
                            <p>Upon a request by the Firm within thirty (30) days of termination, the Provider will
                              delete
                              and cause to be deleted all Firm Data from all computer systems owned and controlled by
                              the
                              Provider.</p>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>

                  <div class="term-content-block flexbox-column gap-16 14">
                    <h6 class="title d-flex gap-4 text-uppercase">
                      <span>14.</span>
                      <span>Confidentiality</span>
                    </h6>

                    <ul class="ps-3 policy-list list-style-none">
                      <li class="policy-list-item d-flex gap-4">
                        <span>14.1</span>
                        <p><span class="fw-semibold text-italic">Definition of Confidential Information.</span> <span
                            class="fw-semibold">“Confidential Information”</span> means all information disclosed by a
                          party (<span class="fw-semibold">“Disclosing Party”</span>) to the other party (<span
                            class="fw-semibold">“Receiving Party”</span>), whether orally or in writing, that is
                          designated as confidential or that reasonably should be understood to be confidential given
                          the
                          nature of the information and the circumstances of disclosure. Firm’s Confidential Information
                          includes Firm Data. The Provider’s Confidential Information includes the Software, the
                          Services
                          and the terms and conditions of this Agreement. However, Confidential Information does not
                          include any information that (a) is or becomes generally known to the public without breach of
                          any obligation owed to the Disclosing Party; (b) was known to the Receiving Party prior to its
                          disclosure by the Disclosing Party without breach of any obligation owed to the Disclosing
                          Party; (c) is received from a third party without breach of any obligation owed to the
                          Disclosing Party; (d) is independently developed by the Receiving Party; or (e) is Feedback
                          from
                          the Firm or its Users.</p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>14.2</span>
                        <p><span class="fw-semibold text-italic">Protection of Confidential Information.</span> The
                          Receiving Party will (a) use the same degree of care that it uses to protect the
                          confidentiality
                          of its own confidential information of like kind (but not less than reasonable care); (b) not
                          use any Confidential Information of the Disclosing Party for any purpose outside the scope of
                          this Agreement; and (c) except as otherwise authorized by the Disclosing Party in writing,
                          limit
                          access to Confidential Information of the Disclosing Party to those of its and its affiliates’
                          employees and contractors who need that access for purposes consistent with this Agreement and
                          who have signed confidentiality agreements with the Receiving Party containing protections no
                          less stringent than those herein.</p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>14.3</span>
                        <p><span class="fw-semibold text-italic">Compelled Disclosure.</span> The Receiving Party may
                          disclose Confidential Information of the Disclosing Party to the extent compelled by law to do
                          so, provided the Receiving Party, if permitted by law, gives the Disclosing Party prior notice
                          of the compelled disclosure.</p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>14.4</span>
                        <p><span class="fw-semibold text-italic">Destruction.</span> Each party, upon the request of the
                          other party or within thirty (30) days after termination of this Agreement (whichever is
                          earlier), agrees to return and cause its representatives to return, all copies of Confidential
                          Information belonging to or provided by the other party or destroy such copies as directed by
                          that party and certify their destruction.</p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>14.5</span>
                        <p><span class="fw-semibold text-italic">Indemnity.</span> Each party agrees to indemnify and
                          hold
                          the other party harmless from and against all loss or damage or any kind and nature suffered
                          by
                          the other party as a result of any breach by it or its representatives of its obligations
                          relating to confidentiality contained in this Section 13.</p>
                      </li>
                    </ul>
                  </div>

                  <div class="term-content-block flexbox-column gap-16 15">
                    <h6 class="title d-flex gap-4 text-uppercase">
                      <span>15.</span>
                      <span>General</span>
                    </h6>

                    <ul class="ps-3 policy-list list-style-none">
                      <li class="policy-list-item d-flex gap-4">
                        <span>15.1</span>
                        <p><span class="fw-semibold text-italic">Governing Law.</span> This Agreement shall be governed
                          by
                          and construed in accordance with the laws of the Province of Ontario and the laws of Canada
                          applicable therein. This Agreement shall be treated, in all respects, as an Ontario contract.
                        </p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>15.2</span>
                        <p><span class="fw-semibold text-italic">Survival.</span> Any terms and conditions of this
                          Agreement which by their nature extend beyond termination of this Agreement shall survive such
                          termination. This includes, without limitation Section 10 (Intellectual Property, Firm Data
                          and
                          Privacy) (but not section 10.3 (License from Firm to Provider)), Section 11 (Disclaimer and
                          Limitation of Liability), Section 12 (Indemnification), Section 13.5 (Effect of Termination),
                          Section 14 (Confidentiality) and applicable provisions of Section 15 (General).</p>
                      </li>
                      <li class="policy-list-item d-flex flex-column gap-8">
                        <div class="flexbox-row gap-4 align-items-start">
                          <span>15.3</span>
                          <p class="m-0"><span class="fw-semibold text-italic">Dispute Resolution.</span></p>
                        </div>

                        <ul class="policy-child-list ps-3 list-style-none">
                          <li class="policy-list-item d-flex gap-4">
                            <span>(a)</span>
                            <p>This Section 15.3 sets out the process (the <span class="fw-semibold">“Dispute Resolution
                                Process”</span>) for resolving all disputes, issues, controversies, and/or claims
                              arising
                              out of or in connection with this Agreement, or in respect of any legal relationship
                              associated with or derived from this Agreement (<span
                                class="fw-semibold">“Disputes”</span>).</p>
                          </li>
                          <li class="policy-list-item d-flex gap-4">
                            <span>(b)</span>
                            <p>Either party may initiate the Dispute Resolution Process by sending a notice of a Dispute
                              (a <span class="fw-semibold">“Dispute Notice”</span>) to the other party. Upon delivery of
                              a
                              Dispute Notice to either party, each party shall appoint a knowledgeable, responsible,
                              non-lawyer, management representative to meet and negotiate in good faith with the
                              representative of the other party in order to resolve the Dispute.</p>
                          </li>
                          <li class="policy-list-item d-flex gap-4">
                            <span>(c)</span>
                            <p>All Disputes that are not resolved within thirty (30) days following delivery of a
                              Dispute
                              Notice shall be arbitrated and finally resolved, with no right of appeal, even on
                              questions
                              of law, pursuant to the National Arbitration Rules of the ADR Institute of Canada, Inc.
                              The
                              place of arbitration shall be Toronto, Ontario, Canada. The language of the arbitration
                              shall be English.</p>
                          </li>
                          <li class="policy-list-item d-flex gap-4">
                            <span>(d)</span>
                            <p>Notwithstanding anything contained in the Agreement to the contrary, either party shall
                              be
                              entitled to seek injunctive or other equitable relief from a court of competent
                              jurisdiction
                              whenever the facts or circumstances would permit a party to seek such relief.</p>
                          </li>
                        </ul>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>15.4</span>
                        <p><span class="fw-semibold text-italic">Relationship.</span> The relationship between the Firm
                          and the Provider will at all times be one of independent contractor and nothing herein shall
                          be
                          construed as implying an employment, partnership, or joint venture relationship. The Provider
                          is
                          not an employee of the Firm and is not entitled to any benefits that the Firm may provide to
                          its
                          employees. Nothing herein shall be construed as empowering either party to act as a
                          representative or agent of the other party. Neither party shall have the authority to enter
                          into
                          any contract, nor to assume any liability, on behalf of the other party, nor to bind or commit
                          the other party in any manner, except as expressly provided in this Agreement.</p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>15.5</span>
                        <p><span class="fw-semibold text-italic">Force Majeure.</span> Except as expressly provided
                          otherwise in this Agreement, dates and times by which the Firm or the Provider is required to
                          perform under this Agreement, the Order Form, or a Schedule (except for any payment
                          obligation)
                          will be postponed automatically to the extent and for the period of time that the Firm or the
                          Provider, as the case may be, is prevented by causes outside of its reasonable control from
                          meeting such dates and times by reason of any cause beyond its reasonable control (provided
                          that
                          a lack of financial resources shall not constitute an event beyond the reasonable control of a
                          party). The following events are deemed to be outside of a party’s reasonable control: acts of
                          God, acts of government, acts of war, civil or military unrest, acts of public enemies,
                          epidemics, riots, fire, unavailability of communications or electrical power service provided
                          by
                          third parties, governmental regulations superimposed after the fact and earthquakes,
                          explosions,
                          floods or other disasters provided that such causes could not have been reasonably foreseen
                          and
                          the risk and/or consequences of such causes mitigated on a commercially reasonable basis. The
                          parties agree that an event shall not be considered to beyond reasonable control if a
                          reasonable
                          business person applying due diligence in the same or similar circumstances under the same or
                          similar obligations as the provisions of the Order Form or Schedule would have put in place
                          contingency plans to either materially mitigate or negate the effects of such event. A party
                          seeking to rely on this Section must (i) notify the other party immediately and in detail of
                          the
                          anticipated or actual commencement of and the cause of postponement; (ii) notify the other
                          party
                          promptly of any material changes in the circumstances which resulted in the postponement
                          including when the reason for the postponement is at an end; and (iii) use diligent efforts to
                          avoid or remove such cause of non-performance and to minimize the consequences thereof,
                          including utilizing all resources reasonably required in the circumstances including without
                          limitation obtaining supplies or services from other resources if they are reasonably
                          available.
                        </p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>15.6</span>
                        <p><span class="fw-semibold text-italic">Non-Solicitation.</span> During the Term and for a
                          period
                          of one (1) year following termination of this Agreement for any reason, the Firm may not,
                          directly or indirectly, (a) solicit for employment any employee or independent contractor of
                          the
                          Provider who was materially involved in the performance of this Agreement; or (b) induce or
                          attempt to induce any employee or independent contractor of the Provider who was materially
                          involved in the performance of this Agreement to leave his or her employ or contract, as
                          applicable, with the Firm. The foregoing will not prevent the Firm from hiring any employee or
                          independent contractor who responds to a job posting or advertisement that is not specifically
                          targeted at such employee or independent contractor.</p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>15.7</span>
                        <p><span class="fw-semibold text-italic">Currency.</span> Unless otherwise specified in the
                          Order
                          Form, all references to amounts of money in this Agreement refer to United States (USD)
                          currency.</p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>15.8</span>
                        <p><span class="fw-semibold text-italic">Notices.</span> Notices that we give to you (other than
                          notice of amendment of this Agreement), may be provided in any of the following ways. First,
                          we
                          may email the Administrator(s) at the contact information provided in the Order Form or any
                          registration data. Second, we may post a notice on the Website. It is your responsibility to
                          periodically review the Website for notices. The Firm may provide notice to the Provider by
                          (a)
                          submitting a ticket through the helpdesk; or (b) e-mailing the Provider.</p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>15.9</span>
                        <p><span class="fw-semibold text-italic">Successors and Assigns.</span> This Agreement shall
                          ensure to the benefit of, and be binding on, the parties and their respective successors and
                          permitted assigns. The Provider may assign this Agreement, in its sole discretion.</p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>15.10</span>
                        <p><span class="fw-semibold text-italic">Severability.</span> Any provision of this Agreement
                          which is prohibited or unenforceable in any jurisdiction will, as to that jurisdiction, be
                          ineffective to the extent of such prohibition or unenforceability and will be severed from the
                          balance of this Agreement, all without affecting the remaining provisions of this Agreement or
                          affecting the validity or enforceability of such provision in any other jurisdiction.</p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>15.11</span>
                        <p><span class="fw-semibold text-italic">Entire Agreement.</span> This Agreement, the Order Form
                          and the Schedules constitute the entire agreement between the parties with respect to the
                          subject matter of this Agreement and supersedes all previous negotiations, proposals,
                          commitments, writings and understandings of any nature whatsoever.</p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>15.12</span>
                        <p><span class="fw-semibold text-italic">Waiver.</span> No term or provision of this Agreement
                          is
                          deemed waived and no breach excused, unless the waiver or consent is in writing and signed by
                          the party claiming to have waived or consented. Any consent by any party to, or waiver of, a
                          breach by the other, whether expressed or implied, does not constitute a consent to, waiver
                          of,
                          or excuse for, any other different or subsequent breach.</p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>15.13</span>
                        <p><span class="fw-semibold text-italic">Fully Negotiated Agreement.</span> The Firm and the
                          Provider acknowledge and agree that all of the provisions of this Agreement have been fully
                          negotiated, that neither of them shall be deemed the drafter of this Agreement and that, in
                          construing this Agreement in case of any claim that any provision hereof may be ambiguous, no
                          such provision shall be construed in favour of one party on the ground that such provision was
                          drafted by the other party.</p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>15.14</span>
                        <p><span class="fw-semibold text-italic">Language.</span> The parties have required that this
                          Agreement and all deeds, documents and notices relating to this Agreement be drawn up in the
                          English language. Les parties aux présentes ont exigé que le présent contrat et tous autres
                          contrats, documents ou avis afférents aux présentes soient rédigés en langue anglaise.</p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>15.15</span>
                        <p><span class="fw-semibold text-italic">Modification of Terms.</span> The Provider may modify
                          this Agreement at any time by (a) posting a notice on the Website or on the Software; or (b)
                          by
                          e-mailing the Administrator(s) of the Firm. The Provider will also update the “Last Updated”
                          date at the top of the Agreement. You are responsible for checking the Agreement whenever you
                          access or use the Services. By continuing to access or use the Services, you are indicating
                          that
                          you agree to be bound by the modified terms. If the modified terms are not acceptable to you,
                          you must stop accessing and using the Services. Notwithstanding the foregoing, the information
                          and material on the Website, and the Website, may be changed, withdrawn or removed at any time
                          in the Provider’s sole discretion without notice.</p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span>15.16</span>
                        <p><span class="fw-semibold text-italic">Questions.</span> If you have any questions regarding
                          these Terms or your use of the Services, please contact us here:</p>
                      </li>
                      <li class="policy-list-item d-flex gap-4">
                        <span class="opacity-0">15.16</span>
                        <div class="flexbox-column gap-2">
                          <h5 class="title">Countable Inc.</h5>
                          <a href="mailto:info@countable.co" class="text-link fs-3">info&#64;countable.co</a>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </ng-container>
            </div>
          </ng-template>

        </mat-tab>


        <mat-tab *ngIf="isLoginPage() ? isLoginPage() : userDetails && userDetails?.origin_country_id == 38">
          <ng-template mat-tab-label>
            {{isLoginPage() ? 'Privacy Policy Canada' : 'Privacy Policy'}}
          </ng-template>
          <ng-template matTabContent>
            <div class="terms-privacy-section">
              <ng-container>
                <!--<h5 class="title">Privacy Policys</h5>-->
                <p class="mar-b-15rem">Countable Inc. <b>(“Countable”, “we”, “us”, “our”</b> and terms of similar
                  meaning) take your privacy rights very seriously. We are committed to transparently describing our
                  privacy practices, including how we collect, use and disclose (a) your personal or personally
                  identifiable information <b>(“Information”)</b>; and (b) non-personal data we obtain from your
                  activity on the Services (as defined below) <b>(“Data”)</b> as part of providing the Countable website
                  (<a class="text-link" href="http://www.countable.co" target="_blank"><b>www.countable.co</b></a>) (the
                  <b>“Site”</b>)
                  and the Countable Platform as a Service (the <b>“Platform”</b>) (collectively, the <b>“Services”</b>).
                </p>
                <p class="mar-b-15rem">We collect, use, and disclose your Information in the ways described in this
                  privacy notice <b>(“Privacy Policy”)</b>. If you disagree with how we collect, use, and disclose your
                  Information, please do not use our Services. </p>
                <p class="mar-b-15rem">We also encourage you to read and understand our Terms and Conditions
                  <b>(“Terms”).</b>
                </p>
                <p class="mar-b-15rem">All capitalized terms that are not otherwise defined in this Privacy Policy
                  obtain their meaning from the Terms.</p>
                <ul>
                  <li class="title-section">
                    <p class="num"><b>1.</b></p>
                    <p class="desc"><b>What Information Do We Collect?</b></p>
                  </li>
                  <ul class="second-child">
                    <li>
                      <p class="num"><b>(a)</b></p>
                      <p class="desc">General. Our primary purpose in collecting Information and Data from you
                        voluntarily is to provide you with a secure, efficient and customized experience when using the
                        Services. We will only ask for and collect Information and Data that we consider necessary to
                        provide our Services. </p>
                    </li>
                    <li>
                      <p class="num"><b>(b)</b></p>
                      <p class="desc">Information and Data.</p>
                    </li>
                    <ul class="third-child">
                      <li>
                        <p class="num"><b>(i)</b></p>
                        <p class="desc">When signing up for a Firm or User account, Firms and Users of the Services must
                          provide the Information as requested or where indicated. Where possible, on these forms we
                          indicate which fields are required and which fields are optional. Our primary purpose in
                          collecting Data from you voluntarily is to provide a secure experience. When using the
                          Services, we may collect, without limitation, Information including: your first and last name,
                          company name, email, address, phone number, professional license number, status with CPA
                          Canada, financial information, other information inputted by you. We may also collect Data
                          generated from your use of the Services. We also collect any personal information that you
                          provide to us via our chatbot. </p>
                      </li>
                      <li>
                        <p class="num"><b>(ii)</b></p>
                        <p class="desc">As you use the Services, you can, or may be required, from time to time enter or
                          send to us Information, which may include, without limitation, Information that you share on
                          your account as a User or Firm.</p>
                      </li>
                    </ul>
                    <li>
                      <p class="num"><b>(c)</b></p>
                      <p class="desc"> Payment and Banking Information. When you add a credit/debit card, payment method
                        or banking information to any Firm account, these payment details will be shared with our third
                        party payment processor(s). We do not store credit/debit card, payment method or banking
                        information on our servers. If you modify which Administrator account provides payment for the
                        Services, we will require that Information to be updated for your continued access to the
                        Services.</p>
                    </li>
                    <li>
                      <p class="num"><b>(d)</b></p>
                      <p class="desc">Information and Data Collected Automatically.</p>
                    </li>
                    <ul class="third-child">
                      <li>
                        <p class="num"><b>(i)</b></p>
                        <p class="desc">
                          When you use the Services, Countable automatically receives and records Data from your device,
                          including, but not limited to your GPS location, IP address, operating Data, device Data,
                          other Platform IDs, cookies, the page you requested, the timing, frequency and pattern of your
                          use of the Services. This usage data may be processed for the purposes of analyzing the use of
                          the Site and the Platform. Unless otherwise stated in this Privacy Policy, Countable only uses
                          this Data in aggregate form.
                        </p>
                      </li>
                      <li>
                        <p class="num"><b>(ii)</b></p>
                        <p class="desc">“Cookies” and similar technologies are small files we and our third-party
                          service providers (e.g., advertising, marketing and analytics), may place on your computer and
                          devices. These technologies are used to help us better provider our Services (for example,
                          analyzing trends, administering the site, tracking users’ movements around the site and to
                          gather demographic information about our user base as a whole.) We may receive reports based
                          on the use of these technologies by these companies on an individual as well as aggregated
                          basis.</p>
                      </li>
                      <li>
                        <p class="desc">We use cookies to remember users’ settings, store login addresses, authenticate
                          users, run website experiments, and store analytics data. You can control the use of cookies
                          at the individual browser level (in your browser settings). If you reject cookies, you may
                          still use our Services, but your ability to use some features or areas of our Site or Services
                          may be limited or may not function properly.</p>
                      </li>
                      <li>
                        <p class="desc">We partner with a third party to either display advertising on our Site or to
                          manage our advertising on other sites. Our third party partner may use technologies such as
                          cookies to gather information about your activities on this Site and other sites in order to
                          provide you advertising based upon your browsing activities and interests. If you wish to not
                          have this information used for the purpose of serving you interest-based ads, you may be able
                          to set your preferences in your browser or your device. Please note this does not opt you out
                          of being served ads. You will continue to receive generic ads.</p>
                      </li>
                    </ul>
                  </ul>
                  <li class="title-section">
                    <p class="num"><b>2.</b></p>
                    <p class="desc"><b>How We Use Your Information and Data</b></p>
                  </li>
                  <p class="mar-b-15rem">We may use your Information to determine your eligibility to register for a
                    Firm or User account or to continue to have a Firm or User account on the Service. We may also use
                    your Information and Data to provide to you the license for the Services; to provide you with the
                    Services; communicate with you, either directly or through one of our partners, including for
                    marketing and promotional purposes; to improve our marketing and promotional efforts; to advise of
                    pricing and Service updates; facilitate transactions and payments (if and as applicable); resolve
                    service disputes; troubleshoot problems; to analyze usage of our Services; to improve our content
                    and product offerings; deliver information to you that, in some cases, is relevant to your
                    interests; customize your experience, the content, layout and services; detect and protect us
                    against error, fraud and other criminal activity; enforce our Terms; provide you with system or
                    administrative messages; and/or as otherwise described to you at the time of collection. These uses
                    improve the Services and better tailor it to meet your needs, so as to provide you with a secure,
                    efficient and customized experience while using the Services.</p>
                  <li class="title-section">
                    <p class="num"><b>3.</b></p>
                    <p class="desc"><b>How We Share Your Information and Data</b></p>
                  </li>
                  <ul class="second-child">
                    <li>
                      <p class="num"></p>
                      <p class="desc">We may share your Information and Data with third parties only in the ways that
                        are described in this Privacy Policy and in accordance with your consent. We will not share,
                        sell or rent your Information or Data to third parties without your explicit consent. </p>
                    </li>
                    <li>
                      <p class="num"><b>(a)</b></p>
                      <p class="desc"><b>To Whom do We Transfer Your Information and Data: </b> </p>
                    </li>
                    <ul class="third-child">
                      <li>
                        <p class="num"><b>(i)</b></p>
                        <p class="desc">Subsidiaries, Affiliates & Service Providers. We may use the services of
                          subsidiaries, affiliates and third party service providers (collectively, “Third Parties”) in
                          connection with our provision of the Services, including, without limitation, for the
                          processing of payments, marketing, off-premise data hosting, communication services, account
                          hosting and Information collecting and analysis services. We may disclose your Information and
                          Data to the Third Parties in the course of our use of their services. We take care to use
                          Third Parties that we believe are reputable and capable of performing the services we require
                          of them, including, without limitation, the handling of confidential information and
                          Information and Data and the compliance with all applicable laws. We use contracts and other
                          measures to ensure these Third Parties have comparable data protection measures to our own,
                          and we only authorize them to use your Information to provide their services to us, not for
                          their own use. </p>
                      </li>
                      <li>
                        <p class="num"><b>(ii)</b></p>
                        <p class="desc">Storing and Processing Your Information and Data Outside Canada. In some cases,
                          Information and Data that we collect may be stored or processed outside of Canada. When that
                          occurs, we continue to protect the Information and Data with appropriate safeguards and data
                          export requirements, but it may be subject to the legal jurisdiction of those countries and
                          governmental authorities in those countries.</p>
                      </li>
                    </ul>
                    <li>
                      <p class="num"><b>(b)</b></p>
                      <p class="desc"><b>How we disclose Information and Data</b></p>
                    </li>
                    <ul class="third-child">
                      <li>
                        <p class="num"><b>(i)</b></p>
                        <p class="desc">Anonymized Aggregated Data. We may aggregate and anonymize your Data and use and
                          disclose it for a variety of purposes, including analytics. We may also use aggregated data of
                          Firms and Users to improve our algorithms, measure service usage, publish summaries and
                          develop new features. We will not display or otherwise disclose information where a Firm or
                          User can be identified. In addition, we do not display or otherwise disclose any Information.
                          Furthermore, we may need to occasionally review raw data and the results for system
                          maintenance. If this review is necessary, we will only see the unique identifier number with
                          the data.</p>
                      </li>
                      <li>
                        <p class="num"><b>(ii)</b></p>
                        <p class="desc">Laws and Jurisdictions. Notwithstanding anything to the contrary in this Privacy
                          Policy, we may preserve or disclose your Information and Data if we believe that it is
                          reasonably necessary to comply with a law, regulation or legal request; to protect the safety
                          of any person; to address fraud, security or technical issues; or to protect our or any other
                          person’s or entity’s rights or property; or as otherwise permitted or required by law.
                          However, nothing in this Privacy Policy is intended to limit any legal defenses or objections
                          that you may have to a third party’s, including a government’s, request to disclose your
                          Information and Data.</p>
                      </li>
                      <li>
                        <p class="num"><b>(iii)</b></p>
                        <p class="desc">Sale of Business. We may disclose Information and Data to the acquiror or its
                          agents in the course of the sale of our business. If we do this, the disclosure will be
                          subject to confidentiality arrangements customary in such transactions.</p>
                      </li>

                    </ul>

                  </ul>
                  <li class="title-section">
                    <p class="num"><b>4.</b></p>
                    <p class="desc"><b>Communication Preferences </b> </p>
                  </li>
                  <p class="mar-b-15rem">You can always unsubscribe from our commercial and promotional emails, but we
                    may still send you communications relating to your status as a Firm and your Users and your use of
                    the Services in accordance with applicable anti-spam legislation.</p>
                  <li class="title-section">
                    <p class="num"><b>5.</b></p>
                    <p class="desc"><b>Information and Data Retention</b></p>
                  </li>
                  <ul class="second-child">
                    <li>
                      <p class="num"><b>(a)</b></p>
                      <p class="desc">General Retention Policy. We securely dispose of your Information after it has
                        fulfilled its purpose, or when the purpose for which it was collected no longer exists. </p>
                    </li>
                    <li>
                      <p class="num"><b>(b)</b></p>
                      <p class="desc">Termination of User Account. If your Firm or User Accounts are terminated, we will
                        deactivate them, but we may retain your Information and Data for a certain period of time for
                        business and contractual reasons and disclose it in a manner consistent with our practices under
                        this Privacy Policy.</p>
                    </li>
                  </ul>
                  <li class="title-section">
                    <p class="num"><b>6.</b></p>
                    <p class="desc"><b>Your Information and Data Rights</b></p>
                  </li>
                  <p class="mar-b-15rem">In accordance with the applicable privacy laws, you may have the following
                    rights with respect to your Information and Data: </p>
                  <ul class="second-child">
                    <li>
                      <p class="num"><b>(a)</b></p>
                      <p class="desc">Right of Access and Portability. You may ask for an overview or copy of your
                        Information and/or Data to be provided to you; and/or transferred to another organization.</p>
                    </li>
                    <li>
                      <p class="num"><b>(b)</b></p>
                      <p class="desc">Right to Rectification. You may review your Information and delete and/or update
                        it through your User Account or by contacting us, to ensure it is accurate and complete on the
                        Services.</p>
                    </li>
                    <li>
                      <p class="num"><b>(c)</b></p>
                      <p class="desc">Right to Erasure and Restriction. You may ask us to remove and/or restrict our
                        processing of your Information and/or Data in certain circumstances e.g. if you believe we have
                        processed your Information and/or Data unlawfully, if you believe that your Information and/or
                        Data is no longer necessary for the purposes in which it was collected or processed, you
                        withdraw your consent (as discussed below). Notwithstanding the foregoing, despite such request,
                        subject to all applicable laws and the terms and conditions of this Privacy Policy, we may still
                        retain your Information and Data for legitimate business interests, to collect any fees owed (if
                        and as applicable), resolve disputes, troubleshoot problems, analyze usage of the Services,
                        assist with any investigations, prevent fraud, enforce our Terms and/or take other actions as
                        required or permitted by law.</p>
                    </li>
                    <li>
                      <p class="num"><b>(d)</b></p>
                      <p class="desc">Right to Withdraw Consent. Where we have asked for your consent to use and/or
                        process your Information and Data, you can withdraw this consent at any time. We will do our
                        best to accommodate your request, subject to applicable laws and the terms and conditions of
                        this Privacy Policy.</p>
                    </li>
                    <p class="mar-b-15rem">Please contact us at <a class="text-link"
                        href="mailto:info@countable.co">info&#64;countable.co</a>
                      if you would like to exercise any of the above rights. </p>
                  </ul>
                  <li class="title-section">
                    <p class="num"><b>7.</b></p>
                    <p class="desc"><b>Security</b></p>
                  </li>
                  <p class="mar-b-15rem">We strive to protect your Information and Data by putting in place a range of
                    technical and organizational measures to safeguard and secure the Information and Data we receive
                    from you, including without limitation, security technologies. We are continuously utilizing
                    security measures to protect your Information and Data from unauthorized access or against loss,
                    misuse or alteration. Despite our efforts, we cannot guarantee the security of your Information and
                    Data. Unauthorized entry or use, hardware or application failure and other factors, may compromise
                    the security of your Information and Data at any time. We reserve the right, without any limitation,
                    to investigate any suspected breaches of the Services’ security or information technology or other
                    systems or networks.</p>
                  <li class="title-section">
                    <p class="num"><b>8.</b></p>
                    <p class="desc"><b>Changes to This Privacy Policy</b></p>
                  </li>
                  <p class="mar-b-15rem">Countable may amend this Privacy Policy from time to time. The use of
                    Information and Data we collect is subject to the Privacy Policy in effect at the time the
                    Information or Data is used. If we make any material changes in the way we use your Information or
                    Data, we will notify you by (a) posting a notice on the Firm and User Account page of the Platform
                    or elsewhere on the Services; or (b) e-mailing you at your e-mail address associated with your Firm,
                    Administrator or User Account. Firms and Users of the Services are bound by any changes to the
                    Privacy Policy when they use the Services after such changes have been first posted.</p>
                  <li class="title-section">
                    <p class="num"><b>9.</b></p>
                    <p class="desc"><b>Questions?</b></p>
                  </li>
                  <p class="mar-b-15rem">It is our goal to make our privacy practices easy to understand. If you have
                    questions, concerns or if you would like more detailed information, please email our data controller
                    at <a class="text-link" href="mailto:info@countable.co">info&#64;countable.co</a>. </p>
                </ul>
              </ng-container>
            </div>
          </ng-template>

        </mat-tab>

        <mat-tab *ngIf="isLoginPage() ? isLoginPage() : userDetails && userDetails?.origin_country_id == 226">
          <ng-template mat-tab-label>
            {{isLoginPage() ? 'Privacy Policy US' : 'Privacy Policy'}}
          </ng-template>
          <ng-template matTabContent>
            <div class="terms-privacy-section">
              <ng-container>

                <p class="mar-b-15rem">Last Updated: June 3 2022</p>
                <p class="mar-b-15rem">Welcome to Countable! This Privacy Policy describes how Countable Inc.
                  (<b>“Countable,”
                    “we”, “us”, “our”</b>) collects, uses, stores, and shares your information when: (1) you access and
                  use our
                  website located at <a class="text-link" href="http://www.countable.co"> www.countable.co</a> or other
                  websites and/or
                  applications owned and operated by us (<b>“Sites”</b>); (2) you engage with our Countable Platform as
                  a
                  service (<b>“Platform”</b>); (3) you communicate with us in any manner (<b>“Communications”</b>); and
                  (4) when
                  we interact with certain third parties, such as our service providers (<b>“Third Parties”</b> ). The
                  Sites and
                  Platform are collectively referred to as our <b>“Services.”</b> </p>
                <p class="mar-b-15rem">This Privacy Policy applies wherever it is posted.</p>

                <ul>
                  <li class="title-section">
                    <h5 class="title">>Acknowledgment</h5>
                  </li>
                  <p class="mar-b-15rem"><b>BY ACCESSING AND/OR USING OUR SERVICES OR COMMUNICATING WITH US IN ANY
                      MANNER, YOU
                      REPRESENT THAT YOU HAVE READ AND UNDERSTAND THIS PRIVACY POLICY. </b></p>

                  <li class="title-section">
                    <h5 class="title">What Type Of Information Do We Collect?</h5>
                  </li>
                  <p class="mar-b-15rem">We collect your information when you interact with our Services, you
                    Communicate with
                    us, and when we engage with Third Parties. </p>
                  <p class="mar-b-15rem"><u><b>Information Provided By You</b></u></p>
                  <p class="mar-b-15rem">We collect the following information directly from you when you interact with
                    our
                    Services or Communicate with us: </p>
                  <ul class="second-child">
                    <li>
                      <p class="desc"><b>• Contact Information</b>, such as your first and last name, company name,
                        mailing
                        address, firm
                        information, email address, and telephone number.</p>
                    </li>
                    <li>
                      <p class="desc"><b>• Professional Information</b>, such as your professional license number,
                        status with
                        CPA Canada or
                        other regulatory bodies, or other information requested concerning your professional background.
                      </p>
                    </li>
                    <li>
                      <p class="desc"><b>• Account Credentials</b>, including your username, password, password hints,
                        and
                        information used
                        for authentication and account access.</p>
                    </li>
                    <li>
                      <p class="desc"><b>• Demographic Information</b>, such as your age, gender, zip code, and country.
                      </p>
                    </li>
                    <li>
                      <p class="desc"><b>• Billing Information</b>, such as your payment information (e.g., credit or
                        debit card
                        number),
                        expiration date, security code, bank account information, or other financial information
                        provided by you
                        when
                        purchasing our Products. We do not store such payment information on our servers.</p>
                    </li>
                    <li>
                      <p class="desc"><b>• Profile Information</b>, such as your interests, preferences, purchasing
                        history,
                        favorites.</p>
                    </li>
                    <li>
                      <p class="desc"><b>• Communications Content</b>, such as any messages you send to us such as
                        feedback and
                        questions to
                        customer support, information you publicly post on our Sites or other websites (such as product
                        reviews
                        or blog
                        comments), e-mail messages, and recordings of telephone calls with customer service or our
                        representatives.</p>
                    </li>
                  </ul>
                  <p class="mar-b-15rem"><u><b>Information Collected Automatically</b></u></p>
                  <p class="mar-b-15rem">When you engage with our Services or Communicate with us via e-mail, we may
                    collect
                    information automatically about your device hardware and software, including but not limited to your
                    IP
                    address, browser type, domain name, access times, geographic location, referring website address and
                    other
                    technical information. For more information about how we collect this information through the use of
                    cookies
                    and related technologies, see <a class="text-link" href="#cookies&trelatedTech">Cookies & Related
                      Technologies</a>
                    below. </p>
                  <p class="mar-b-15rem"><u><b>Information Collected From Third Parties</b></u></p>
                  <p class="mar-b-15rem">We use a variety of Third Parties to provide you with the Services. From time
                    to time,
                    we may collect information about you from those Third Parties, including for fraud protection
                    purposes,
                    authentication and verification, and other related business and commercial purposes</p>

                  <li class="title-section">
                    <h5 class="title">How Do We Use Your Information?</h5>
                  </li>
                  <p class="mar-b-15rem">We may use the information we collect from and about you to: </p>
                  <ul class="second-child">
                    <li>
                      <p class="num"><b>•</b></p>
                      <p class="desc">Improve our Services;</p>
                    </li>
                    <li>
                      <p class="num"><b>•</b></p>
                      <p class="desc">Offer our Services to you;</p>
                    </li>
                    <li>
                      <p class="num"><b>•</b></p>
                      <p class="desc">Deliver our Services;</p>
                    </li>
                    <li>
                      <p class="num"><b>•</b></p>
                      <p class="desc">Personalize our Services;</p>
                    </li>
                    <li>
                      <p class="num"><b>•</b></p>
                      <p class="desc">facilitate transactions and payments;</p>
                    </li>
                    <li>
                      <p class="num"><b>•</b></p>
                      <p class="desc">Resolve service disputes, or otherwise troubleshoot problems;</p>
                    </li>
                    <li>
                      <p class="num"><b>•</b></p>
                      <p class="desc">Enforce our terms and policies;</p>
                    </li>
                    <li>
                      <p class="num"><b>•</b> </p>
                      <p class="desc">Provide you with information about our Services;</p>
                    </li>
                    <li>
                      <p class="num"><b>•</b></p>
                      <p class="desc">Customer service;</p>
                    </li>
                    <li>
                      <p class="num"><b>•</b></p>
                      <p class="desc">Security and to detect fraud and illegal activities;</p>
                    </li>
                    <li>
                      <p class="num"><b>•</b></p>
                      <p class="desc">Research and analytical purposes;</p>
                    </li>
                    <li>
                      <p class="num"><b>•</b></p>
                      <p class="desc">To fulfill your requests;</p>
                    </li>
                    <li>
                      <p class="num"><b>•</b></p>
                      <p class="desc">To Communicate with you;</p>
                    </li>
                    <li>
                      <p class="num"><b>•</b></p>
                      <p class="desc">To facilitate a business transaction, such as a merger, acquisition, asset sale,
                        bankruptcy, or
                        other related proceeding;</p>
                    </li>
                    <li>
                      <p class="num"><b>•</b></p>
                      <p class="desc">Ad measurement purposes, delivery of ads, marketing, and other ways to personalize
                        our
                        Services
                        for you;</p>
                    </li>
                    <li>
                      <p class="num"><b>•</b></p>
                      <p class="desc">To comply with the law, enforce our policies, or respond to a legal request such
                        as a
                        subpoena;</p>
                    </li>
                    <li>
                      <p class="num"><b>•</b></p>
                      <p class="desc">And for any other purpose described by us in any relevant notice.</p>
                    </li>
                  </ul>

                  <li class="title-section">
                    <h5 class="title">How Do We Share Your Information?</h5>
                  </li>
                  <p class="num">Depending on the circumstances, we may share your information in the following
                    circumstances:
                  </p>
                  <ul class="second-child">
                    <li>
                      <p class="num"><b>•</b></p>
                      <p class="desc"><b><u>With Your Consent.</u></b> We may disclose, share, or make available your
                        information with your consent, which may be obtained in writing, online, through “click-through”
                        agreements, when you accept our terms for our Sites, orally (including over the telephone), or
                        by other
                        means.</p>
                    </li>
                    <li>
                      <p class="num"><b>•</b></p>
                      <p class="desc"> <b><u>With Service Providers & Business Partners.</u></b> We may disclose, share,
                        or make
                        available your information with our third-party service providers, business partners, and other
                        third
                        parties, such as credit / debit card processing partners, partners that facilitate billing,
                        shipping,
                        and customer service, third-party auditors and law firms, marketing and advertising networks
                        (including
                        those that provide ad measurement services), internet service providers, data analytics
                        providers,
                        companies that help debug and identify and repair errors that may impair the functionality of
                        our Sites,
                        and third parties that help protect against malicious, deceptive, fraudulent, or illegal
                        activity.</p>
                    </li>
                    <li>
                      <p class="num"><b>•</b></p>
                      <p class="desc"> <b><u>In A Business Transfer. </u></b> We may disclose, share, or make available
                        your
                        information as part of a business transaction, such as a merger or acquisition, joint venture,
                        corporate
                        reorganization, financing, or sale of company assets, or in the unlikely event of insolvency,
                        bankruptcy, or receivership, in which such information could be transferred to third parties as
                        a
                        business asset in the transaction.</p>
                    </li>
                    <li>
                      <p class="num"><b>•</b></p>
                      <p class="desc"> <b> <u>For Legal Process & Protection. </u></b> We may disclose, share, or make
                        available
                        your information to satisfy any law, regulation, legal process, governmental request, or where
                        we have a
                        good faith belief that access, use, preservation or disclosure of such information is reasonably
                        necessary to: (1) enforce or apply agreements, or initiate, render, or bill for use of the
                        Sites; (2)
                        protect our rights or interests, property or safety or that of others; (3) in connection with
                        claims,
                        disputes, or litigation - in court or elsewhere; (4) protect users of our Services and other
                        carriers,
                        providers, or partners from fraudulent, abusive, unlawful, or otherwise improper use of our
                        Sites; (5)
                        facilitate or verify the appropriate calculation of taxes, fees, or other obligations due to a
                        local,
                        state, or federal government.</p>
                    </li>
                  </ul>
                  <li class="title-section">
                    <h5 id="cookies&trelatedTech"><b>Cookies & Related Technology</b></h5>
                  </li>
                  <p class="mar-b-15rem">From time to time, our Sites may use cookies, beacons, pixel tags, scripts, and
                    other
                    similar technologies. We use these technologies to support the functionality of our Sites, perform
                    analytics, advertise our Sites and Products, determine how users interact with our Sites, and for
                    other
                    related purposes. Below is an overview of these technologies. To learn more about your choices with
                    regard
                    to these technologies, see Your Choices below. </p>
                  <p class="mar-b-15rem"><b><u>What Are Cookies? </u></b> A cookie is a small file containing a string
                    of
                    characters that is sent to your computer or device when you visit a website or use an online
                    service. The
                    cookie then communicates with servers, ours (e.g., first-party cookies) or those of another
                    third-party
                    (e.g., third-party cookies) that we have authorized to place on our Sites. When you visit our Sites
                    again,
                    the cookie allows us to recognize your browser or device. Cookies may store unique identifiers, user
                    preferences, and other information.</p>
                  <p class="mar-b-15rem"><b><u>How Long Do Cookies Last? </u></b> We may use “session cookies” or
                    “persistent
                    cookies.” Session cookies are temporary and expire once you close your browser or once your session
                    ends.
                    Persistent cookies remain on your device for much longer or until you or your browser erase them.
                    Persistent
                    cookies have varying durations that are dependent on their expiration date. For more information
                    about what
                    cookies are being set, and their duration, you may visit our Cookie Manager Tool . </p>
                  <p class="mar-b-15rem"><b><u>What Types Of Cookies Do We Use?</u></b></p>
                  <ul class="second-child">
                    <li>
                      <p class="num"><b>•</b></p>
                      <p class="desc"><b>Necessary Cookies. </b> These cookies are necessary for you to browse the Sites
                        and use
                        their features, such as accessing secure areas of the Sites. Without these cookies, certain
                        aspects of
                        the Sites may not be available to you. </p>
                    </li>
                    <li>
                      <p class="num"><b>•</b></p>
                      <p class="desc"><b>Preferences Cookies. </b> These cookies collect information about how you have
                        used the
                        Sites in the past and allow the Sites to remember the choices you have made. These cookies allow
                        us to
                        improve how the Sites work for you and tailor the Sites to your preferences. </p>
                    </li>
                    <li>
                      <p class="num"><b>•</b></p>
                      <p class="desc"><b>Statistics Cookies. </b> These cookies collect information about how you use
                        the Sites,
                        such as which pages you most often visit on the Sites, the time you spend on the Sites, which
                        links you
                        click on, and any issues encountered. These cookies help us understand how visitors interact
                        with the
                        Sites. All information collected is aggregated and do not identify you. </p>
                    </li>
                    <li>
                      <p class="num"><b>•</b></p>
                      <p class="desc"><b>Marketing Cookies. </b> These cookies track your online activity to help
                        deliver
                        advertisements that are relevant to you and your interests and measure the effectiveness of the
                        advertising campaigns. They also limit how many times you see a certain advertisement. We may
                        share the
                        information collected through these cookies with others, such as advertisers. </p>
                    </li>
                  </ul>
                  <p class="mar-b-15rem"><b><u>Beacons. </u></b> Our Sites, and some of our e-mail communications, may
                    from time
                    to time contain small electronic files known as beacons (also known as web beacons, clear GIFs,
                    pixel tags,
                    single-pixel GIFS) that permit us, for example, to count users who have visited those pages or
                    opened an
                    email communication, and for other related statistical analysis. Beacons in email marketing
                    campaigns allow
                    us to track your responses and your interests in our content, offerings, and Sites. You may use the
                    tools in
                    your device to disable these technologies as well. </p>
                  <li class="title-section">
                    <h5 class="title">Links To Third Party Sites</h5>
                  </li>
                  <p class="mar-b-15rem">Our Services, from time to time, may contain links to third-party websites and
                    services. Please note that these links are provided for your convenience and information, and may
                    operate
                    independently from us and have their own privacy policies and/or notices. You are strongly
                    encouraged to
                    review such policies or notices. We do not endorse or make any representations or warranties
                    concerning, and
                    will not in any way be liable for, any informational content, products, services, software, or other
                    materials available on other websites, even if one or more pages of the other websites are framed
                    within, or
                    linked to, a page of our Services.</p>
                  <li class="title-section">
                    <h5 class="title">Do Not Track</h5>
                  </li>
                  <p class="mar-b-15rem"> Our Sites may, from time to time, collect information about your online
                    activities,
                    overtime time and across our Sites. Third parties may also collect information about your online
                    activities,
                    over time and across different internet websites, online or cloud computing services, online
                    applications,
                    or mobile applications. Some browsers support a “Do Not Track” feature, which is intended to be a
                    signal to
                    websites that you do not wish to be tracked across different websites you visit. Our Sites do not
                    currently
                    change the way they operate based upon detection of a “Do Not Track” or similar signal. </p>
                  <li class="title-section">
                    <h5 class="title">How Do We Store & Protect Your Information</h5>
                  </li>
                  <p class="mar-b-15rem">Although no system or website can guarantee the complete security of your
                    information,
                    we take all commercially reasonable steps to ensure your information is protected in accordance with
                    all
                    applicable laws and regulations, as appropriate to the sensitivity of your information. </p>
                  <li class="title-section">
                    <h5 class="title">How Long Do We Keep Your Information?</h5>
                  </li>
                  <p class="mar-b-15rem">We keep your information for as long as necessary in accordance with the
                    purposes for
                    which it was collected, our business needs, and our legal and regulatory obligations. If we dispose
                    of your
                    information, we will do so in a way that is commercially reasonable taking into account the
                    sensitivity of
                    the information. </p>

                  <li class="title-section">
                    <h5 class="title">Your Choices</h5>
                  </li>
                  <p class="mar-b-15rem">We provide you with the ability to exercise certain controls and choices about
                    how we
                    collect, use, share, and store your information.
                    Please note, for some of these rights (such as the Right to Access and Right to Delete), we may take
                    steps
                    to verify your identity by matching the information you provide with your request with the
                    information we
                    have on file about you. Depending on the sensitivity of the information at issue, we may utilize
                    more
                    stringent verification methods, including but not limited to requiring you to sign a declaration
                    under
                    penalty of perjury.
                  </p>
                  <p class="mar-b-15rem">To submit any of the requests below, or have a request submitted by your
                    representative, please submit your request to <a class="text-link"
                      href="mailto:info@countable.co">info&#64;countable.co.</a> </p>
                  <ul class="second-child">
                    <li>
                      <p class="num"><b>•</b></p>
                      <p class="desc"><b><u>Right of Access. </u></b> Depending on where you live, you may have a right
                        to ask
                        that we disclose to you the categories and in some cases specific information we have collected
                        about
                        you in the 12 months preceding the date of your request, or as otherwise required under
                        applicable law,
                        including information about from where we collected this information and how it has been shared.
                      </p>
                    </li>
                    <li>
                      <p class="num"><b>•</b></p>
                      <p class="desc"><b><u>Right to Correct. </u></b> Depending on where you live, you may have a right
                        to
                        correct the information we have about you, subject to certain restrictions recognized by law.
                      </p>
                    </li>
                    <li>
                      <p class="num"><b>•</b></p>
                      <p class="desc"><b><u>Right to Delete. </u></b> Depending on where you live, you may have the
                        right to ask
                        that we delete your information, subject to appropriate legal exceptions such as, but not
                        limited to, if
                        the information is necessary to complete a transaction with you, detect security incidents,
                        protect
                        against malicious, deceptive, fraudulent, or illegal activity, comply with the law, or to use
                        internally
                        for purposes aligned with your expectations. </p>
                    </li>
                    <li>
                      <p class="num"><b>•</b></p>
                      <p class="desc"><b><u>Right to Opt-Out of the Sale of Personal Information. </u></b>. If you are a
                        resident of California, you have a right to opt-out of the sale of your personal information.
                        Although
                        we do not sell your personal information in the traditional sense, we do share some of your
                        information,
                        such as your IP address and other identifiers, with third-party advertising partners which may
                        constitute a sale under California law. To exercise this right, you may send an e-mail to <a
                          class="text-link" href="mailto:info@countable.com"> info&#64;countable.com</a> or visit <b> Do
                          Not Sell My Personal
                          Information</b> .</p>
                    </li>
                    <li>
                      <p class="num"><b>•</b></p>
                      <p class="desc"><b><u>Right to Change Preferences.</u></b> . If you no longer want to receive
                        certain
                        communications from us via email or text message, simply click the “unsubscribe” link in the
                        email or
                        reply STOP (or as otherwise instructed) to the message. Please note, you may not be able to
                        unsubscribe
                        from service-related correspondence from us, such as message relating to your account and use of
                        our
                        Sites. </p>
                    </li>
                    <li>
                      <p class="num"><b>•</b></p>
                      <p class="desc"><b><u>Right to Non-Discrimination.</u></b> We will not discriminate against you in
                        any way
                        if you choose to exercise your rights under this section and applicable law.</p>
                    </li>
                    <li>
                      <p class="num"><b>•</b></p>
                      <p class="desc"><b><u>Changing Cookie / Related Technology Settings. </u></b> To manage the
                        cookies on our
                        Sites, please see our Cookie Manager Tool. In addition, web browsers allow some control of most
                        cookies
                        through browser settings. To find out more about cookies, including how to manage and delete
                        cookies
                        through browser settings, visit <a class="text-link"
                          href="www.allaboutcookies.org">www.allaboutcookies.org</a>.
                        Some web
                        browsers provide settings that allow a user to reject cookies or to alert a user when a cookie
                        is placed
                        on the user’s computer, tablet or mobile device. Most mobile devices also offer settings to
                        reject
                        mobile device identifiers. Although users are not required to accept cookies or mobile device
                        identifiers, blocking or rejecting them may prevent access to some features available through
                        the Sites.
                        In addition to adjusting your browser and device settings, as outlined above, you may also
                        control how
                        cookies and related technologies are set and used on your device by visiting the following
                        sites:</p>
                    </li>

                    <ul class="third-child">
                      <li>
                        <p class="num"><b>o </b></p><a class="text-link"
                          href="http://networkadvertising.org/">http://networkadvertising.org/</a>
                      </li>
                      <li>
                        <p class="num"><b>o </b></p><a class="text-link"
                          href="http://optout.aboutads.info/">http://optout.aboutads.info/</a>
                      </li>
                      <li>
                        <p class="num"><b>o </b></p><a class="text-link"
                          href="http://youradchoices.com/">http://youradchoices.com/</a>
                      </li>
                    </ul>
                  </ul>
                  <li class="title-section">
                    <h5 class="title">Changes</h5>
                  </li>
                  <p class="mar-b-15rem">We may change this Privacy Policy from time to time. Any and all changes to
                    this
                    Privacy Policy will be reflected on this page, and where appropriate provided in person or by
                    another
                    electronic method. Material changes to this Privacy Policy will be posted here, and may be provided
                    via
                    e-mail or another method, as appropriate under applicable law. The last updated date will be stated
                    at the
                    top of this Privacy Policy. You should regularly check this page for any changes to this Privacy
                    Policy.</p>

                  <li class="title-section">
                    <h5 class="title">Contact</h5>
                  </li>
                  <p class="mar-b-15rem"><a class="text-link"
                      href="mailto:contact@countable.co">contact&#64;countable.co</a></p>

                </ul>
              </ng-container>
            </div>
          </ng-template>

        </mat-tab>

        <mat-tab>
          <ng-template mat-tab-label>
            Service Level Agreement
          </ng-template>
          <ng-template matTabContent>
            <div class="terms-privacy-section">
              <p class="mar-b-15rem"><b>THIS SERVICE LEVEL AGREEMENT (“Schedule”)</b> forms a part of the Countable SaaS
                Terms and Conditions between Countable Inc. and the Firm, as amended from time to time (the
                <b>“Terms”</b>). Capitalized terms used in this Schedule but not defined in this Schedule are used as
                defined in the License.
              </p>

              <ul>
                <li class="title-section">
                  <p class="num"><b>1.</b></p>
                  <p class="desc"><b>SUPPORT</b></p>
                </li>
                <ul class="second-child">
                  <li>
                    <p class="num"><b>1.1</b></p>
                    <p class="desc"><i>Support Obligations.</i> The Provider will provide support relating to the
                      Software and Services to the Firm and Users in accordance with this Schedule (each request for
                      support, a <b>“Request”</b>). </p>
                  </li>
                  <li>
                    <p class="num"><b>1.2</b></p>
                    <p class="desc"><i>Support Tickets.</i> The Firm and Users may submit support requests through the
                      Provider’s online helpdesk ticketing system. </p>
                  </li>
                  <li>
                    <p class="num"><b>1.3</b></p>
                    <p class="desc"><b>Support Hours.</b> Subject to the response timetable below, support will be
                      available between the hours of 9 am EST and 5 pm EST on each Business Day (each such hour is
                      hereafter referred to as a <b>“Business Hour”</b>). </p>
                  </li>
                  <li>
                    <p class="num"><b>1.4</b></p>
                    <p class="desc"><i>Training.</i> Provider will provide a reasonable amount of training to the Firm
                      personnel. </p>
                  </li>
                </ul>
                <li class="title-section">
                  <p class="num"><b>2.</b></p>
                  <p class="desc"><b>SUPPORT ISSUE SEVERITY LEVELS, RESPONSE TIMES, ISSUE RESOLUTION, AND ESCALATION</b>
                  </p>
                </li>
                <ul class="second-child">
                  <li>
                    <p class="num"><b>2.1</b></p>
                    <p class="desc"><i>Issue Response.</i> Provider will respond to Requests in accordance with the
                      table below. The Severity Level will be determined by Provider in its reasonable discretion. </p>
                  </li>
                  <ul class="third-child">
                    <li>
                      <table class="table table-bordered">
                        <thead>
                          <tr>
                            <th>SEVERITY LEVEL</th>
                            <th colspan="2">SEVERITY LEVEL RESPONSE COMMITMENT TIME TABLE</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td></td>
                            <td style="width:30%;">
                              <p>Initial Response</p>
                            </td>
                            <td>
                              <p>On-going Communication on Problem Resolution</p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p><b>Critical</b></p>
                              <p>Causes a severe impact to the Firm’s ability to use the software (e.g. software is
                                inaccessible)</p>
                              <p>No immediately available work around.</p>
                            </td>
                            <td>
                              <p>Four (4) Business Hours</p>
                            </td>
                            <td>
                              <p>Provider will make all commercially reasonable efforts, taking into consideration the
                                critical nature of the issue, to resolve the problem or provide a workaround while
                                keeping the Firm or affected Users who submitted the Request updated at least every
                                business day until closure of the support incident.</p>
                              <p>Critical issues will be assigned to the most senior developer available, who will work
                                exclusively on resolving the critical issue during all business hours.</p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p><b>High</b></p>
                              <p>Causes a noncritical impact to the Firm’s ability to use the software operations (e.g.
                                software is accessible but some critical data and/or features are unavailable)</p>
                              <p>No immediately available work around.</p>
                            </td>
                            <td>
                              <p>Four (4) Business Hours</p>
                            </td>
                            <td>
                              <p>Provider will make all commercially reasonable efforts, taking into consideration the
                                high severity of the issue, to resolve the problem or provide a workaround while keeping
                                the Firm or affected Users who submitted the Request updated at least every two (2)
                                business days until closure of the support incident.</p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p><b>Low</b></p>
                              <p>Causes the Firm to be unable to perform certain tasks or use non-critical features of
                                the software. </p>
                            </td>
                            <td>
                              <p>One (1) business day</p>
                            </td>
                            <td>
                              <p>Provider will make reasonable efforts to resolve the problem or provide a workaround
                                while keeping the Firm or affected Users who submitted the Request updated at least
                                every three (3) business days until closure of the support incident.</p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </li>
                  </ul>
                  <li>
                    <p class="num"><b>2.2</b></p>
                    <p class="desc"><i>Escalation.</i> Support issues may be escalated by the Firm as follows.</p>
                  </li>
                  <ul class="third-child">
                    <li>
                      <p class="num"><b>(a)</b></p>
                      <p class="desc"><b>Severity Escalation:</b> Firm may escalate the severity of a Request by
                        notifying Provider’s support resources, if there are extenuating circumstances that cause or
                        could cause the support issue to have an adverse impact on Firm’s business or its relationship
                        with its Clients and Users. The request to escalate the severity of a support issue may be
                        initiated by submitting or updating a ticket with the word “escalate” in the subject line. </p>
                    </li>
                    <li>
                      <p class="num"><b>(b)</b></p>
                      <p class="desc"><b>Managerial Escalation:</b> The Firm may request managerial escalation of a
                        Request by contacting Provider’s applicable contact persons. Issues may be escalated through
                        subsequent levels of management as required until the support issue is resolved.</p>
                    </li>
                  </ul>
                </ul>
              </ul>
            </div>
          </ng-template>

        </mat-tab>
      </mat-tab-group>
      @if(!isShowAcceptButton()){
        <div class="flexbox-row justify-content-end pt-3 border-top">
          <mat-checkbox class="example-margin" [formControl]="isChecked">
            <span class="fw-semibold">I agree to the Terms and Conditions</span>
        </mat-checkbox>
          <button mat-button mat-flat-button color="primary" class="button-default" mat-dialog-close (click)="accept()"
            style="flex:initial;" [disabled]="!isChecked.value">Accept and Proceed</button>
        </div>
      }
    </div>
  </div>

</ng-template>


